var animationData = {
  v: "5.11.0",
  fr: 23.9760437011719,
  ip: 0,
  op: 720.001312347504,
  w: 800,
  h: 800,
  nm: "full-o_Base-4",
  ddd: 0,
  assets: [
    {id: "image_0", w: 157, h: 157, u: "/wp-content/themes/apexanalytix/assets/images/about-us/", p: "img_0.png", e: 0},
    {id: "image_1", w: 189, h: 309, u: "/wp-content/themes/apexanalytix/assets/images/about-us/", p: "img_1.png", e: 0},
    {id: "image_2", w: 374, h: 211, u: "/wp-content/themes/apexanalytix/assets/images/about-us/", p: "img_2.png", e: 0},
    {id: "image_3", w: 198, h: 391, u: "/wp-content/themes/apexanalytix/assets/images/about-us/", p: "img_3.png", e: 0},
    {id: "image_4", w: 221, h: 461, u: "/wp-content/themes/apexanalytix/assets/images/about-us/", p: "img_4.png", e: 0},
    {id: "image_5", w: 415, h: 318, u: "/wp-content/themes/apexanalytix/assets/images/about-us/", p: "img_5.png", e: 0},
    {id: "image_6", w: 383, h: 297, u: "/wp-content/themes/apexanalytix/assets/images/about-us/", p: "img_6.png", e: 0},
    {id: "image_7", w: 222, h: 489, u: "/wp-content/themes/apexanalytix/assets/images/about-us/", p: "img_7.png", e: 0},
  ],
  fonts: {
    list: [
      {
        fName: "EuphemiaUCAS-Bold",
        fFamily: "Euphemia UCAS",
        fStyle: "Bold",
        ascent: 76.513671875,
      },
    ],
  },
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 3,
      nm: "Controll layer",
      sr: 1,
      ks: {
        o: {a: 0, k: 0, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [400, 400, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      ip: 0,
      op: 720.001312347504,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 5,
      nm: "We",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [324.742, 59.127, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "We",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [0.012, 0.369, 0.647],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 5,
      nm: "achieve",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [360.742, 59.127, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "achieve",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [0.012, 0.369, 0.647],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 5,
      nm: "our",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [439.242, 59.127, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "our",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [0.012, 0.369, 0.647],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 5,
      nm: "“why”",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [309.254, 84.116, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "“why”",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [0.012, 0.369, 0.647],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 5,
      nm: "through",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [370.254, 84.116, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "through",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [0.012, 0.369, 0.647],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 5,
      nm: "our 2",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [449.254, 84.116, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "our",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [0.012, 0.369, 0.647],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 8,
      ty: 5,
      nm: "culture",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [350.607, 110.627, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "culture",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [0.012, 0.369, 0.647],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 9,
      ty: 5,
      nm: "of:",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [422.607, 110.627, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "of:",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [0.012, 0.369, 0.647],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 10,
      ty: 5,
      nm: "Our",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [351.164, 221.127, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "Our",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [0.514, 0.192, 0.184],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 11,
      ty: 5,
      nm: "“why” 2",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [393.164, 221.127, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "“why”",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [0.514, 0.192, 0.184],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 12,
      ty: 5,
      nm: "to",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [373.25, 270.627, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "to",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [0.514, 0.192, 0.184],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 13,
      ty: 5,
      nm: "be:",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [397.75, 270.627, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "be:",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [0.514, 0.192, 0.184],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 14,
      ty: 5,
      nm: "pushes",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [351.992, 245.627, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "pushes",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [0.514, 0.192, 0.184],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 15,
      ty: 5,
      nm: "us",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [422.492, 245.627, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "us",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [0.514, 0.192, 0.184],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 16,
      ty: 5,
      nm: "Fun.",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [62, 345, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "Fun.",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 17,
      ty: 5,
      nm: "Candor.",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [177.5, 674, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "Candor.",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 18,
      ty: 5,
      nm: "Respect.",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [535, 674, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "Respect.",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 19,
      ty: 5,
      nm: "Why",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [362.36, 396.5, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "Why",
                ca: 0,
                j: 0,
                tr: -30,
                lh: 25.2000007629395,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 20,
      ty: 5,
      nm: "we",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [412.36, 396.5, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "we",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 21,
      ty: 5,
      nm: " exist.",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [361.64, 422, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: " exist.",
                ca: 0,
                j: 0,
                tr: 34,
                lh: 25.2000007629395,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 22,
      ty: 5,
      nm: "Smart.",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [206, 382.5, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "Smart.",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 23,
      ty: 5,
      nm: "Hungry.     ",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [362, 561, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "Hungry.     ",
                ca: 0,
                j: 0,
                tr: -25,
                lh: 25.2000007629395,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 24,
      ty: 5,
      nm: "Humble.",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [520.5, 382.5, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "Humble.",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 25,
      ty: 5,
      nm: "Performance.",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [656.5, 345.5, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      t: {
        d: {
          k: [
            {
              s: {
                s: 21,
                f: "EuphemiaUCAS-Bold",
                t: "Performance.",
                ca: 0,
                j: 0,
                tr: -53,
                lh: 25.2000007629395,
                ls: 0,
                fc: [1, 1, 1],
              },
              t: 0,
            },
          ],
        },
        p: {},
        m: {g: 1, a: {a: 0, k: [0, 0], ix: 2}},
        a: [],
      },
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 26,
      ty: 2,
      nm: "WhyWeGlow.png",
      cl: "png",
      refId: "image_0",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {x: [0.833], y: [0.833]},
              o: {x: [0.167], y: [0.167]},
              t: 127,
              s: [0],
            },
            {t: 130.000236951633, s: [100]},
          ],
          ix: 11,
        },
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [400, 400, 0], ix: 2, l: 2},
        a: {a: 0, k: [78.5, 78.5, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      ip: 127.000231483518,
      op: 141.000257001386,
      st: 120.000218724584,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 27,
      ty: 2,
      nm: "HumbleGlow.png",
      cl: "png",
      refId: "image_1",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {x: [0.833], y: [0.833]},
              o: {x: [0.167], y: [0.167]},
              t: 112,
              s: [0],
            },
            {t: 115.00020961106, s: [100]},
          ],
          ix: 11,
        },
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [546, 379, 0], ix: 2, l: 2},
        a: {a: 0, k: [94.5, 154.5, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      ip: 112.000204142945,
      op: 126.000229660813,
      st: 105.000191384011,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 28,
      ty: 2,
      nm: "HungryGlow.png",
      cl: "png",
      refId: "image_2",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {x: [0.833], y: [0.833]},
              o: {x: [0.167], y: [0.167]},
              t: 97,
              s: [0],
            },
            {t: 100.000182270487, s: [100]},
          ],
          ix: 11,
        },
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [437, 536, 0], ix: 2, l: 2},
        a: {a: 0, k: [187, 105.5, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      ip: 97.000176802372,
      op: 111.00020232024,
      st: 90.000164043438,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 29,
      ty: 2,
      nm: "SmartGlow.png",
      cl: "png",
      refId: "image_3",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {x: [0.833], y: [0.833]},
              o: {x: [0.167], y: [0.167]},
              t: 82,
              s: [0],
            },
            {t: 85.0001549299136, s: [100]},
          ],
          ix: 11,
        },
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [258, 419.5, 0], ix: 2, l: 2},
        a: {a: 0, k: [99, 195.5, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      ip: 82.000149461799,
      op: 96.0001749796672,
      st: 75.000136702865,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 30,
      ty: 2,
      nm: "PerformanceGlow.png",
      cl: "png",
      refId: "image_4",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {x: [0.833], y: [0.833]},
              o: {x: [0.167], y: [0.167]},
              t: 67,
              s: [0],
            },
            {t: 70.0001275893407, s: [100]},
          ],
          ix: 11,
        },
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [692, 358, 0], ix: 2, l: 2},
        a: {a: 0, k: [110.5, 230.5, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      ip: 67.000122121226,
      op: 81.0001476390942,
      st: 83.0001512845039,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 31,
      ty: 2,
      nm: "RespectGlow.png",
      cl: "png",
      refId: "image_5",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {x: [0.833], y: [0.833]},
              o: {x: [0.167], y: [0.167]},
              t: 52,
              s: [0],
            },
            {t: 55.0001002487676, s: [100]},
          ],
          ix: 11,
        },
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [567, 643, 0], ix: 2, l: 2},
        a: {a: 0, k: [207.5, 159, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      ip: 52.0000947806531,
      op: 66.0001202985212,
      st: 67.000122121226,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 32,
      ty: 2,
      nm: "CandorGlow.png",
      cl: "png",
      refId: "image_6",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {x: [0.833], y: [0.833]},
              o: {x: [0.167], y: [0.167]},
              t: 37,
              s: [0],
            },
            {t: 40.0000729081947, s: [100]},
          ],
          ix: 11,
        },
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [243, 651, 0], ix: 2, l: 2},
        a: {a: 0, k: [191.5, 148.5, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      ip: 37.0000674400801,
      op: 51.0000929579482,
      st: 52.0000947806531,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 33,
      ty: 2,
      nm: "FunGlow.png",
      cl: "png",
      refId: "image_7",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {x: [0.833], y: [0.833]},
              o: {x: [0.167], y: [0.167]},
              t: 22,
              s: [0],
            },
            {t: 25.0000455676217, s: [100]},
          ],
          ix: 11,
        },
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [107, 371, 0], ix: 2, l: 2},
        a: {a: 0, k: [111, 244.5, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      ip: 22.0000400995071,
      op: 36.0000656173752,
      st: 52.0000947806531,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 34,
      ty: 4,
      nm: "Blue_Segment_Fun_Drop_Shadow Outlines",
      sr: 1,
      ks: {
        o: {a: 0, k: 85, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [111.445, 364.931, 0], ix: 2, l: 2},
        a: {a: 0, k: [111.472, 244.149, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "st",
              c: {a: 0, k: [0, 0, 0, 1], ix: 3},
              o: {a: 0, k: 100, ix: 4},
              w: {a: 0, k: 0, ix: 5},
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false,
            },
            {
              ty: "gf",
              o: {a: 0, k: 100, ix: 10},
              r: 1,
              bm: 0,
              g: {
                p: 3,
                k: {
                  a: 0,
                  k: [
                    0.002, 0, 0, 0, 0.489, 0, 0, 0, 0.999, 0, 0, 0, 0, 0.45,
                    0.5, 0.225, 1, 0,
                  ],
                  ix: 9,
                },
              },
              s: {a: 0, k: [0, 0], ix: 5},
              e: {a: 0, k: [100, 0], ix: 6},
              t: 2,
              h: {a: 0, k: 0, ix: 7},
              a: {a: 0, k: 0, ix: 8},
              nm: "Gradient Fill 1",
              mn: "ADBE Vector Graphic - G-Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: {a: 0, k: [0, 0], ix: 2},
              a: {a: 0, k: [0, 0], ix: 1},
              s: {a: 0, k: [100, 100], ix: 3},
              r: {a: 0, k: 0, ix: 6},
              o: {a: 0, k: 100, ix: 7},
              sk: {a: 0, k: 0, ix: 4},
              sa: {a: 0, k: 0, ix: 5},
              nm: "Transform",
            },
          ],
          nm: "Shape 2",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ty: "st",
              c: {a: 0, k: [0, 0, 0, 1], ix: 3},
              o: {a: 0, k: 100, ix: 4},
              w: {a: 0, k: 0, ix: 5},
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: "Stroke 1",
              mn: "ADBE Vector Graphic - Stroke",
              hd: false,
            },
            {
              ty: "gf",
              o: {a: 0, k: 100, ix: 10},
              r: 1,
              bm: 0,
              g: {
                p: 3,
                k: {
                  a: 0,
                  k: [
                    0.002, 0, 0, 0, 0.489, 0, 0, 0, 0.999, 0, 0, 0, 0, 0.45,
                    0.5, 0.225, 1, 0,
                  ],
                  ix: 9,
                },
              },
              s: {a: 0, k: [0, 0], ix: 5},
              e: {a: 0, k: [100, 0], ix: 6},
              t: 2,
              h: {a: 0, k: 0, ix: 7},
              a: {a: 0, k: 0, ix: 8},
              nm: "Gradient Fill 1",
              mn: "ADBE Vector Graphic - G-Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: {a: 0, k: [0, 0], ix: 2},
              a: {a: 0, k: [0, 0], ix: 1},
              s: {a: 0, k: [100, 100], ix: 3},
              r: {a: 0, k: 0, ix: 6},
              o: {a: 0, k: 100, ix: 7},
              sk: {a: 0, k: 0, ix: 4},
              sa: {a: 0, k: 0, ix: 5},
              nm: "Transform",
            },
          ],
          nm: "Shape 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-23.07, 22.963],
                    [-28.97, -29.11],
                    [-2.002, -2.632],
                    [1.823, 43.246],
                    [0.037, 1.237],
                    [0.008, 0.331],
                    [-0.217, 5.492],
                    [-0.186, 2.572],
                    [-0.099, 1.174],
                    [-0.012, 0.138],
                    [-0.173, 1.605],
                    [-15.138, 28.312],
                    [-0.777, 1.398],
                    [-0.417, 0.734],
                    [-0.23, 0.398],
                    [-0.278, 0.476],
                    [-4.41, 6.19],
                    [-1.902, 2.47],
                    [31.642, 23.805],
                    [24.569, -32.659],
                    [13.59, -39.968],
                    [0, -43.994],
                    [-20.84, -49.27],
                    [-10.425, -16.987],
                  ],
                  o: [
                    [29.11, -28.97],
                    [2.391, 2.4],
                    [-22.297, -36.159],
                    [-0.055, -1.235],
                    [-0.009, -0.331],
                    [-0.14, -5.476],
                    [0.107, -2.564],
                    [0.083, -1.177],
                    [0.012, -0.138],
                    [0.142, -1.604],
                    [3.373, -32.146],
                    [0.747, -1.406],
                    [0.409, -0.736],
                    [0.229, -0.398],
                    [0.275, -0.477],
                    [3.91, -6.69],
                    [1.818, -2.558],
                    [21.931, -32.437],
                    [-32.661, -24.57],
                    [-25.465, 33.851],
                    [-14.055, 41.334],
                    [0, 53.867],
                    [7.84, 18.536],
                    [-13.406, -27.747],
                  ],
                  v: [
                    [-37.865, 158.859],
                    [67.285, 159.119],
                    [73.861, 166.684],
                    [37.021, 45.994],
                    [36.885, 42.287],
                    [36.852, 41.295],
                    [36.965, 24.839],
                    [37.419, 17.133],
                    [37.687, 13.606],
                    [37.724, 13.193],
                    [38.201, 8.379],
                    [66.166, -82.901],
                    [68.448, -87.108],
                    [69.693, -89.312],
                    [70.376, -90.508],
                    [71.195, -91.941],
                    [83.695, -111.271],
                    [89.291, -118.797],
                    [72.439, -219.329],
                    [-31.183, -204.681],
                    [-90.041, -93.434],
                    [-111.222, 35.158],
                    [-79.816, 190.591],
                    [-52.378, 243.899],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ty: "tr",
                  p: {a: 0, k: [0, 0], ix: 2},
                  a: {a: 0, k: [0, 0], ix: 1},
                  s: {a: 0, k: [100, 100], ix: 3},
                  r: {a: 0, k: 0, ix: 6},
                  o: {a: 0, k: 100, ix: 7},
                  sk: {a: 0, k: 0, ix: 4},
                  sa: {a: 0, k: 0, ix: 5},
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 0,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "mm",
              mm: 4,
              nm: "Merge Paths 1",
              mn: "ADBE Vector Filter - Merge",
              hd: false,
            },
            {
              ty: "gf",
              o: {a: 0, k: 100, ix: 10},
              r: 1,
              bm: 0,
              g: {
                p: 3,
                k: {
                  a: 0,
                  k: [
                    0.002, 0, 0, 0, 0.489, 0, 0, 0, 0.999, 0, 0, 0, 0, 0.45,
                    0.5, 0.225, 1, 0,
                  ],
                  ix: 9,
                },
              },
              s: {a: 0, k: [-6.769, 257.465], ix: 5},
              e: {a: 0, k: [153.071, 305.468], ix: 6},
              t: 2,
              h: {a: 0, k: 0, ix: 7},
              a: {a: 0, k: 0, ix: 8},
              nm: "Gradient Fill 1",
              mn: "ADBE Vector Graphic - G-Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: {a: 0, k: [111.472, 244.149], ix: 2},
              a: {a: 0, k: [0, 0], ix: 1},
              s: {a: 0, k: [100, 100], ix: 3},
              r: {a: 0, k: 0, ix: 6},
              o: {a: 0, k: 100, ix: 7},
              sk: {a: 0, k: 0, ix: 4},
              sa: {a: 0, k: 0, ix: 5},
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 3,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 35,
      ty: 4,
      nm: "Blue_Segment_Candor_Drop_Shadow Outlines",
      sr: 1,
      ks: {
        o: {a: 0, k: 85, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [243.301, 650.743, 0], ix: 2, l: 2},
        a: {a: 0, k: [191.636, 148.609, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [8.526, 32.092],
                    [0, 0],
                    [-39.68, 10.54],
                    [-1.53, 0.3],
                    [10.86, 0.35],
                    [0.42, 0.02],
                    [0.61, 0.03],
                    [14.89, 3.4],
                    [11.15, 4.3],
                    [0.26, 0.1],
                    [0.5, 0.19],
                    [11.08, 6.47],
                    [11.75, 10.23],
                    [0.02, 0.02],
                    [0.36, 0.32],
                    [11.055, 15.501],
                    [0.751, 1.082],
                    [0.186, 0.272],
                    [0.232, 0.35],
                    [1.976, 3.202],
                    [2.425, 2.425],
                    [29.11, -28.96],
                    [-13.336, -27.73],
                    [-22.392, -22.393],
                    [-47.553, -20.113],
                    [-53.867, 0],
                    [-11.73, 1.028],
                  ],
                  o: [
                    [0, 0],
                    [-10.54, -39.68],
                    [1.53, -0.41],
                    [-10.75, 1.04],
                    [-0.41, -0.01],
                    [-0.61, -0.02],
                    [-14.74, -0.69],
                    [-11.99, -2.74],
                    [-0.26, -0.1],
                    [-0.49, -0.19],
                    [-11.56, -4.61],
                    [-13.94, -8.15],
                    [-0.02, -0.02],
                    [-0.36, -0.31],
                    [-14.367, -12.71],
                    [-0.769, -1.071],
                    [-0.187, -0.271],
                    [-0.236, -0.343],
                    [-2.125, -3.119],
                    [-2.011, -2.661],
                    [-28.97, -29.11],
                    [-23.042, 22.935],
                    [16.336, 26.638],
                    [36.644, 36.644],
                    [49.271, 20.84],
                    [11.899, 0],
                    [-31.495, -1.494],
                  ],
                  v: [
                    [123.339, 91.897],
                    [123.349, 91.907],
                    [176.099, 0.977],
                    [180.689, -0.083],
                    [148.249, 0.957],
                    [147.009, 0.907],
                    [145.169, 0.827],
                    [100.649, -5.263],
                    [65.909, -15.853],
                    [65.139, -16.153],
                    [63.659, -16.733],
                    [29.649, -33.343],
                    [-8.911, -61.003],
                    [-8.961, -61.053],
                    [-10.041, -62.003],
                    [-48.249, -104.499],
                    [-50.531, -107.727],
                    [-51.101, -108.533],
                    [-51.802, -109.576],
                    [-57.951, -119.058],
                    [-64.591, -126.703],
                    [-169.741, -126.963],
                    [-184.303, -42.024],
                    [-126.137, 31.668],
                    [0.751, 117.203],
                    [156.185, 148.61],
                    [191.636, 147.064],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "gf",
              o: {a: 0, k: 100, ix: 10},
              r: 1,
              bm: 0,
              g: {
                p: 3,
                k: {
                  a: 0,
                  k: [
                    0.002, 0, 0, 0, 0.489, 0, 0, 0, 0.999, 0, 0, 0, 0, 0.45,
                    0.5, 0.225, 1, 0,
                  ],
                  ix: 9,
                },
              },
              s: {a: 0, k: [197.853, 135.663], ix: 5},
              e: {a: 0, k: [368.949, 123.928], ix: 6},
              t: 2,
              h: {a: 0, k: 0, ix: 7},
              a: {a: 0, k: 0, ix: 8},
              nm: "Gradient Fill 1",
              mn: "ADBE Vector Graphic - G-Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: {a: 0, k: [191.636, 148.609], ix: 2},
              a: {a: 0, k: [0, 0], ix: 1},
              s: {a: 0, k: [100, 100], ix: 3},
              r: {a: 0, k: 0, ix: 6},
              o: {a: 0, k: 100, ix: 7},
              sk: {a: 0, k: 0, ix: 4},
              sa: {a: 0, k: 0, ix: 5},
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 36,
      ty: 4,
      nm: "Blue_Segment_Respect_Drop_Shadow Outlines",
      sr: 1,
      ks: {
        o: {a: 0, k: 85, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [567.391, 642.808, 0], ix: 2, l: 2},
        a: {a: 0, k: [203.283, 155.008, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [32.846, 9.164],
                    [0, 0],
                    [-10.83, 39.461],
                    [0.041, -0.095],
                    [25.87, -25.87],
                    [55.544, -6.693],
                    [0.363, -0.036],
                    [1.53, -0.41],
                    [-10.54, -39.67],
                    [-31.468, -1.521],
                    [-2.347, 0.248],
                    [-0.407, 0.044],
                    [-2.327, 0.294],
                    [-0.239, 0.031],
                    [-2.162, 0.313],
                    [-0.353, 0.052],
                    [-2.289, 0.379],
                    [-0.373, 0.063],
                    [-2.129, 0.395],
                    [-0.24, 0.045],
                    [-2.269, 0.467],
                    [-0.438, 0.091],
                    [-2.263, 0.516],
                    [-0.011, 0.002],
                    [-2.265, 0.559],
                    [-0.463, 0.116],
                    [-2.232, 0.601],
                    [-0.166, 0.045],
                    [-2.087, 0.602],
                    [-0.453, 0.132],
                    [-2.173, 0.677],
                    [-0.359, 0.113],
                    [-1.946, 0.645],
                    [-0.394, 0.132],
                    [-2.139, 0.757],
                    [-0.453, 0.162],
                    [-1.954, 0.735],
                    [-0.268, 0.102],
                    [-2.12, 0.844],
                    [-0.492, 0.199],
                    [-2.138, 0.904],
                    [-36.645, 36.644],
                    [-20.114, 47.554],
                    [-1.081, 2.72],
                    [0, 0],
                  ],
                  o: [
                    [0, 0],
                    [-39.45, -11],
                    [-0.035, 0.093],
                    [-12.418, 33.281],
                    [-40.176, 40.177],
                    [-0.362, 0.053],
                    [-1.53, 0.31],
                    [-39.68, 10.54],
                    [8.52, 32.07],
                    [2.355, -0.206],
                    [0.407, -0.042],
                    [2.334, -0.253],
                    [0.24, -0.03],
                    [2.169, -0.278],
                    [0.353, -0.052],
                    [2.298, -0.339],
                    [0.373, -0.062],
                    [2.136, -0.36],
                    [0.241, -0.045],
                    [2.279, -0.427],
                    [0.439, -0.09],
                    [2.272, -0.476],
                    [0.011, -0.002],
                    [2.274, -0.519],
                    [0.463, -0.114],
                    [2.241, -0.561],
                    [0.165, -0.044],
                    [2.096, -0.567],
                    [0.454, -0.131],
                    [2.183, -0.639],
                    [0.36, -0.112],
                    [1.954, -0.614],
                    [0.395, -0.131],
                    [2.149, -0.72],
                    [0.453, -0.16],
                    [1.962, -0.703],
                    [0.268, -0.101],
                    [2.131, -0.806],
                    [0.493, -0.196],
                    [2.149, -0.865],
                    [47.554, -20.113],
                    [36.643, -36.644],
                    [1.142, -2.701],
                    [0, 0],
                    [-16.843, 27.803],
                  ],
                  v: [
                    [119.759, -62.367],
                    [119.819, -62.357],
                    [67.696, -155.008],
                    [67.57, -154.723],
                    [9.765, -65.048],
                    [-137.343, 6.711],
                    [-138.431, 6.853],
                    [-148.021, 8.913],
                    [-200.771, 99.843],
                    [-132.541, 155.008],
                    [-125.489, 154.322],
                    [-124.269, 154.193],
                    [-117.277, 153.376],
                    [-116.559, 153.282],
                    [-110.063, 152.394],
                    [-109.004, 152.241],
                    [-102.123, 151.163],
                    [-101.004, 150.973],
                    [-94.606, 149.842],
                    [-93.884, 149.71],
                    [-87.063, 148.365],
                    [-85.748, 148.091],
                    [-78.945, 146.61],
                    [-78.911, 146.603],
                    [-72.103, 144.98],
                    [-70.714, 144.635],
                    [-64.003, 142.896],
                    [-63.508, 142.76],
                    [-57.234, 141.002],
                    [-55.872, 140.609],
                    [-49.337, 138.638],
                    [-48.259, 138.297],
                    [-42.408, 136.408],
                    [-41.224, 136.017],
                    [-34.793, 133.8],
                    [-33.436, 133.314],
                    [-27.561, 131.159],
                    [-26.756, 130.859],
                    [-20.381, 128.379],
                    [-18.903, 127.786],
                    [-12.471, 125.139],
                    [114.418, 39.604],
                    [199.953, -87.285],
                    [203.283, -95.419],
                    [203.283, -95.42],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "gf",
              o: {a: 0, k: 100, ix: 10},
              r: 1,
              bm: 0,
              g: {
                p: 3,
                k: {
                  a: 0,
                  k: [
                    0.002, 0, 0, 0, 0.489, 0, 0, 0, 0.999, 0, 0, 0, 0, 0.45,
                    0.5, 0.225, 1, 0,
                  ],
                  ix: 9,
                },
              },
              s: {a: 0, k: [126.594, -127.487], ix: 5},
              e: {a: 0, k: [245.328, -197.364], ix: 6},
              t: 2,
              h: {a: 0, k: 0, ix: 7},
              a: {a: 0, k: 0, ix: 8},
              nm: "Gradient Fill 1",
              mn: "ADBE Vector Graphic - G-Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: {a: 0, k: [203.283, 155.008], ix: 2},
              a: {a: 0, k: [0, 0], ix: 1},
              s: {a: 0, k: [100, 100], ix: 3},
              r: {a: 0, k: 0, ix: 6},
              o: {a: 0, k: 100, ix: 7},
              sk: {a: 0, k: 0, ix: 4},
              sa: {a: 0, k: 0, ix: 5},
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 37,
      ty: 4,
      nm: "Red_Segment_Hungry_Shadow Outlines",
      sr: 1,
      ks: {
        o: {a: 0, k: 95, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [431.523, 535.678, 0], ix: 2, l: 2},
        a: {a: 0, k: [188.112, 101.757, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [35.28, 12.48],
                    [-10.57, 37.41],
                    [0.27, -0.6],
                    [1.06, -1.96],
                    [1.72, -2.54],
                    [0.51, -0.71],
                    [0.17, -0.22],
                    [0.82, -1.02],
                    [0.45, -0.53],
                    [5.86, -4.234],
                    [0.022, -0.017],
                    [0.071, -0.052],
                    [0.138, -0.099],
                    [0.562, -0.38],
                    [0.001, -0.001],
                    [0, 0],
                    [18.592, 0],
                    [13.591, 8.401],
                    [17.081, -34.21],
                    [-31.31, -20.358],
                    [-39.05, 0],
                    [-44.783, 44.781],
                    [-11.766, 29.129],
                  ],
                  o: [
                    [-37.17, -13.15],
                    [-0.26, 0.61],
                    [-0.91, 2.05],
                    [-1.45, 2.71],
                    [-0.49, 0.73],
                    [-0.16, 0.22],
                    [-0.77, 1.05],
                    [-0.44, 0.55],
                    [-4.63, 5.471],
                    [-0.022, 0.017],
                    [-0.072, 0.052],
                    [-0.138, 0.1],
                    [-0.552, 0.391],
                    [-0.001, 0],
                    [0, 0],
                    [-14.298, 9.778],
                    [-17.118, 0],
                    [-35.078, -12.874],
                    [-17.06, 34.169],
                    [33.597, 17.688],
                    [63.33, 0],
                    [22.884, -22.884],
                    [-16.905, 32.175],
                  ],
                  v: [
                    [97.288, -11.268],
                    [50.518, -101.508],
                    [49.727, -99.688],
                    [46.778, -93.668],
                    [42.008, -85.798],
                    [40.497, -83.647],
                    [40.008, -82.978],
                    [37.628, -79.888],
                    [36.288, -78.268],
                    [20.486, -63.669],
                    [20.421, -63.62],
                    [20.206, -63.464],
                    [19.795, -63.164],
                    [18.132, -61.999],
                    [18.129, -61.997],
                    [18.13, -61.999],
                    [-32.036, -46.492],
                    [-78.748, -59.751],
                    [-170.802, -23.138],
                    [-142.285, 74.43],
                    [-32.036, 101.508],
                    [135.617, 32.064],
                    [187.863, -46.702],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ty: "tr",
                  p: {a: 0, k: [0, 0], ix: 2},
                  a: {a: 0, k: [0, 0], ix: 1},
                  s: {a: 0, k: [100, 100], ix: 3},
                  r: {a: 0, k: 0, ix: 6},
                  o: {a: 0, k: 100, ix: 7},
                  sk: {a: 0, k: 0, ix: 4},
                  sa: {a: 0, k: 0, ix: 5},
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 0,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "mm",
              mm: 4,
              nm: "Merge Paths 1",
              mn: "ADBE Vector Filter - Merge",
              hd: false,
            },
            {
              ty: "gf",
              o: {a: 0, k: 100, ix: 10},
              r: 1,
              bm: 0,
              g: {
                p: 3,
                k: {
                  a: 0,
                  k: [
                    0.002, 0, 0, 0, 0.489, 0, 0, 0, 0.999, 0, 0, 0, 0, 0.45,
                    0.5, 0.225, 1, 0,
                  ],
                  ix: 9,
                },
              },
              s: {a: 0, k: [151.294, -80.401], ix: 5},
              e: {a: 0, k: [287.006, -133.989], ix: 6},
              t: 2,
              h: {a: 0, k: 0, ix: 7},
              a: {a: 0, k: 0, ix: 8},
              nm: "Gradient Fill 1",
              mn: "ADBE Vector Graphic - G-Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: {a: 0, k: [188.112, 101.758], ix: 2},
              a: {a: 0, k: [0, 0], ix: 1},
              s: {a: 0, k: [100, 100], ix: 3},
              r: {a: 0, k: 0, ix: 6},
              o: {a: 0, k: 100, ix: 7},
              sk: {a: 0, k: 0, ix: 4},
              sa: {a: 0, k: 0, ix: 5},
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 38,
      ty: 4,
      nm: "Red_Segment_Smart_Shadow Outlines",
      sr: 1,
      ks: {
        o: {a: 0, k: 95, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [257.789, 413.986, 0], ix: 2, l: 2},
        a: {a: 0, k: [95.648, 196.371, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [-17.06, 34.168],
                    [-35.078, -12.874],
                    [0, 32.009],
                    [-11.824, 15.561],
                    [32.542, 24.725],
                    [24.725, -32.542],
                    [0, -52.251],
                    [-44.782, -44.781],
                    [-20.89, -10.998],
                  ],
                  o: [
                    [-31.31, -20.358],
                    [17.081, -34.211],
                    [-25.413, -15.71],
                    [0, -19.641],
                    [24.724, -32.541],
                    [-32.541, -24.726],
                    [-31.551, 41.526],
                    [0, 63.331],
                    [17.169, 17.169],
                    [0, 0],
                  ],
                  v: [
                    [31.449, 195.898],
                    [2.931, 98.554],
                    [94.986, 61.939],
                    [52.602, -13.897],
                    [70.674, -67.706],
                    [56.52, -171.396],
                    [-47.17, -157.242],
                    [-95.398, -13.897],
                    [-25.954, 153.755],
                    [31.449, 196.121],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ty: "tr",
                  p: {a: 0, k: [0, 0], ix: 2},
                  a: {a: 0, k: [0, 0], ix: 1},
                  s: {a: 0, k: [100, 100], ix: 3},
                  r: {a: 0, k: 0, ix: 6},
                  o: {a: 0, k: 100, ix: 7},
                  sk: {a: 0, k: 0, ix: 4},
                  sa: {a: 0, k: 0, ix: 5},
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 0,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gf",
              o: {a: 0, k: 100, ix: 10},
              r: 1,
              bm: 0,
              g: {
                p: 3,
                k: {
                  a: 0,
                  k: [
                    0, 0, 0, 0, 0.5, 0, 0, 0, 1, 0, 0, 0, 0, 0.45, 0.529, 0.23,
                    1, 0.01,
                  ],
                  ix: 9,
                },
              },
              s: {a: 0, k: [137.572, 315.719], ix: 5},
              e: {a: 0, k: [-14.418, 24.364], ix: 6},
              t: 2,
              h: {a: 0, k: 0, ix: 7},
              a: {a: 0, k: 0, ix: 8},
              nm: "Gradient Fill 1",
              mn: "ADBE Vector Graphic - G-Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: {a: 0, k: [96.222, 197.29], ix: 2},
              a: {a: 0, k: [0, 0], ix: 1},
              s: {a: 0, k: [100, 100], ix: 3},
              r: {a: 0, k: 0, ix: 6},
              o: {a: 0, k: 100, ix: 7},
              sk: {a: 0, k: 0, ix: 4},
              sa: {a: 0, k: 0, ix: 5},
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 39,
      ty: 4,
      nm: "Black_Disk Outlines",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [400, 400, 0], ix: 2, l: 2},
        a: {a: 0, k: [74.31, 74.31, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-40.902, 0],
                    [0, -40.902],
                    [40.902, 0],
                    [0, 40.902],
                  ],
                  o: [
                    [40.902, 0],
                    [0, 40.902],
                    [-40.902, 0],
                    [0, -40.902],
                  ],
                  v: [
                    [0, -74.06],
                    [74.06, 0],
                    [0, 74.06],
                    [-74.06, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ty: "tr",
                  p: {a: 0, k: [0, 0], ix: 2},
                  a: {a: 0, k: [0, 0], ix: 1},
                  s: {a: 0, k: [100, 100], ix: 3},
                  r: {a: 0, k: 0, ix: 6},
                  o: {a: 0, k: 100, ix: 7},
                  sk: {a: 0, k: 0, ix: 4},
                  sa: {a: 0, k: 0, ix: 5},
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 0,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gf",
              o: {a: 0, k: 100, ix: 10},
              r: 1,
              bm: 0,
              g: {
                p: 3,
                k: {
                  a: 0,
                  k: [
                    0.001, 0, 0, 0, 0.488, 0.131, 0.131, 0.131, 0.999, 0.263,
                    0.263, 0.263,
                  ],
                  ix: 9,
                },
              },
              s: {a: 0, k: [-72.444, 0.082], ix: 5},
              e: {a: 0, k: [87.289, 2.667], ix: 6},
              t: 1,
              nm: "Gradient Fill 1",
              mn: "ADBE Vector Graphic - G-Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: {a: 0, k: [74.31, 74.31], ix: 2},
              a: {a: 0, k: [0, 0], ix: 1},
              s: {a: 0, k: [100, 100], ix: 3},
              r: {a: 0, k: 0, ix: 6},
              o: {a: 0, k: 100, ix: 7},
              sk: {a: 0, k: 0, ix: 4},
              sa: {a: 0, k: 0, ix: 5},
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 40,
      ty: 4,
      nm: "Blue_Segment_Base Outlines",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [393.288, 458.135, 0], ix: 2, l: 2},
        a: {a: 0, k: [399.514, 339.41, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [53.867, 0],
                    [49.27, 20.84],
                    [36.644, 36.643],
                    [20.113, 47.554],
                    [0, 53.868],
                    [-14.054, 41.334],
                    [-25.465, 33.85],
                    [-32.66, -24.57],
                    [24.57, -32.659],
                    [0, -54.946],
                    [-47.457, -47.457],
                    [-67.115, 0],
                    [-47.457, 47.458],
                    [0, 67.115],
                    [32.912, 43.749],
                    [-32.66, 24.569],
                    [-24.57, -32.659],
                    [-13.591, -39.968],
                    [0, -43.993],
                    [20.84, -49.271],
                    [36.644, -36.645],
                    [47.553, -20.114],
                  ],
                  o: [
                    [-53.868, 0],
                    [-47.553, -20.114],
                    [-36.644, -36.645],
                    [-20.84, -49.271],
                    [0, -43.993],
                    [13.591, -39.968],
                    [24.568, -32.659],
                    [32.66, 24.569],
                    [-32.912, 43.75],
                    [0, 67.115],
                    [47.458, 47.458],
                    [67.114, 0],
                    [47.458, -47.457],
                    [0, -54.946],
                    [-24.569, -32.66],
                    [32.658, -24.57],
                    [25.464, 33.85],
                    [14.055, 41.333],
                    [0, 53.868],
                    [-20.113, 47.554],
                    [-36.644, 36.643],
                    [-49.271, 20.84],
                  ],
                  v: [
                    [0, 339.16],
                    [-155.434, 307.754],
                    [-282.322, 222.219],
                    [-367.857, 95.33],
                    [-399.264, -60.104],
                    [-378.083, -188.695],
                    [-319.224, -299.942],
                    [-215.603, -314.59],
                    [-200.955, -210.969],
                    [-251.264, -60.104],
                    [-177.67, 117.566],
                    [0, 191.16],
                    [177.67, 117.566],
                    [251.264, -60.104],
                    [200.955, -210.967],
                    [215.604, -314.589],
                    [319.225, -299.941],
                    [378.083, -188.694],
                    [399.264, -60.104],
                    [367.857, 95.33],
                    [282.322, 222.219],
                    [155.434, 307.754],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ty: "tr",
                  p: {a: 0, k: [0, 0], ix: 2},
                  a: {a: 0, k: [0, 0], ix: 1},
                  s: {a: 0, k: [100, 100], ix: 3},
                  r: {a: 0, k: 0, ix: 6},
                  o: {a: 0, k: 100, ix: 7},
                  sk: {a: 0, k: 0, ix: 4},
                  sa: {a: 0, k: 0, ix: 5},
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 0,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gf",
              o: {a: 0, k: 100, ix: 10},
              r: 1,
              bm: 0,
              g: {
                p: 3,
                k: {
                  a: 0,
                  k: [
                    0.001, 0.165, 0.365, 0.616, 0.488, 0.235, 0.502, 0.704,
                    0.999, 0.306, 0.639, 0.792,
                  ],
                  ix: 9,
                },
              },
              s: {a: 0, k: [-395.397, -5.955], ix: 5},
              e: {a: 0, k: [390.465, 5.322], ix: 6},
              t: 1,
              nm: "Gradient Fill 1",
              mn: "ADBE Vector Graphic - G-Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: {a: 0, k: [405.49, 342.115], ix: 2},
              a: {a: 0, k: [0, 0], ix: 1},
              s: {a: 0, k: [100, 100], ix: 3},
              r: {a: 0, k: 0, ix: 6},
              o: {a: 0, k: 100, ix: 7},
              sk: {a: 0, k: 0, ix: 4},
              sa: {a: 0, k: 0, ix: 5},
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 41,
      ty: 4,
      nm: "Red_Segment_Base Outlines",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [399.486, 427.524, 0], ix: 2, l: 2},
        a: {a: 0, k: [237.346, 209.911, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [63.33, 0],
                    [44.781, 44.781],
                    [0, 63.331],
                    [-31.551, 41.526],
                    [-32.541, -24.726],
                    [24.724, -32.542],
                    [0, -19.64],
                    [-49.128, 0],
                    [0, 49.127],
                    [11.824, 15.561],
                    [-32.541, 24.725],
                    [-24.724, -32.543],
                    [0, -52.251],
                    [44.782, -44.783],
                  ],
                  o: [
                    [-63.331, 0],
                    [-44.782, -44.782],
                    [0, -52.25],
                    [24.724, -32.542],
                    [32.542, 24.724],
                    [-11.824, 15.561],
                    [0, 49.127],
                    [49.128, 0],
                    [0, -19.641],
                    [-24.724, -32.542],
                    [32.54, -24.725],
                    [31.552, 41.527],
                    [0, 63.331],
                    [-44.782, 44.781],
                  ],
                  v: [
                    [0, 209.661],
                    [-167.652, 140.218],
                    [-237.096, -27.435],
                    [-188.868, -170.779],
                    [-85.178, -184.933],
                    [-71.023, -81.243],
                    [-89.096, -27.435],
                    [0, 61.661],
                    [89.096, -27.435],
                    [71.022, -81.245],
                    [85.176, -184.936],
                    [188.866, -170.782],
                    [237.096, -27.435],
                    [167.652, 140.218],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ty: "tr",
                  p: {a: 0, k: [0, 0], ix: 2},
                  a: {a: 0, k: [0, 0], ix: 1},
                  s: {a: 0, k: [100, 100], ix: 3},
                  r: {a: 0, k: 0, ix: 6},
                  o: {a: 0, k: 100, ix: 7},
                  sk: {a: 0, k: 0, ix: 4},
                  sa: {a: 0, k: 0, ix: 5},
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 0,
              cix: 2,
              bm: 0,
              ix: 2,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "gf",
              o: {a: 0, k: 100, ix: 10},
              r: 1,
              bm: 0,
              g: {
                p: 3,
                k: {
                  a: 0,
                  k: [
                    0.002, 0.514, 0.192, 0.184, 0.489, 0.602, 0.202, 0.194,
                    0.999, 0.69, 0.212, 0.204,
                  ],
                  ix: 9,
                },
              },
              s: {a: 0, k: [-234.071, 0.289], ix: 5},
              e: {a: 0, k: [233.068, 2.061], ix: 6},
              t: 1,
              nm: "Gradient Fill 1",
              mn: "ADBE Vector Graphic - G-Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: {a: 0, k: [237.733, 210.64], ix: 2},
              a: {a: 0, k: [0, 0], ix: 1},
              s: {a: 0, k: [100, 100], ix: 3},
              r: {a: 0, k: 0, ix: 6},
              o: {a: 0, k: 100, ix: 7},
              sk: {a: 0, k: 0, ix: 4},
              sa: {a: 0, k: 0, ix: 5},
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 42,
      ty: 4,
      nm: "Red_Disk_Base Outlines",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [399.486, 400.089, 0], ix: 2, l: 2},
        a: {a: 0, k: [237.346, 237.346, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [49.128, 0],
                    [0, -49.128],
                    [-49.128, 0],
                    [0, 49.128],
                  ],
                  o: [
                    [-49.128, 0],
                    [0, 49.128],
                    [49.128, 0],
                    [0, -49.128],
                  ],
                  v: [
                    [0, -89.096],
                    [-89.096, 0],
                    [0, 89.096],
                    [89.096, 0],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 1,
              ty: "sh",
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [63.33, 0],
                    [44.781, 44.781],
                    [0, 63.331],
                    [-44.782, 44.781],
                    [-63.331, 0],
                    [-44.782, -44.782],
                    [0, -63.33],
                    [44.782, -44.783],
                  ],
                  o: [
                    [-63.331, 0],
                    [-44.782, -44.783],
                    [0, -63.33],
                    [44.781, -44.782],
                    [63.331, 0],
                    [44.782, 44.782],
                    [0, 63.33],
                    [-44.782, 44.781],
                  ],
                  v: [
                    [0, 237.096],
                    [-167.652, 167.653],
                    [-237.096, 0],
                    [-167.652, -167.652],
                    [0, -237.096],
                    [167.652, -167.652],
                    [237.096, 0],
                    [167.652, 167.653],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 2",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ty: "tr",
                  p: {a: 0, k: [0, 0], ix: 2},
                  a: {a: 0, k: [0, 0], ix: 1},
                  s: {a: 0, k: [100, 100], ix: 3},
                  r: {a: 0, k: 0, ix: 6},
                  o: {a: 0, k: 100, ix: 7},
                  sk: {a: 0, k: 0, ix: 4},
                  sa: {a: 0, k: 0, ix: 5},
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 0,
              cix: 2,
              bm: 0,
              ix: 3,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.89019613827, 0.760784373564, 0.756862804936, 1],
                ix: 4,
              },
              o: {a: 0, k: 100, ix: 5},
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: {a: 0, k: [237.346, 237.346], ix: 2},
              a: {a: 0, k: [0, 0], ix: 1},
              s: {a: 0, k: [100, 100], ix: 3},
              r: {a: 0, k: 0, ix: 6},
              o: {a: 0, k: 100, ix: 7},
              sk: {a: 0, k: 0, ix: 4},
              sa: {a: 0, k: 0, ix: 5},
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 43,
      ty: 4,
      nm: "Blue_Disk_Base Outlines",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [399.486, 400.089, 0], ix: 2, l: 2},
        a: {a: 0, k: [399.514, 399.513, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ind: 0,
              ty: "sh",
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [67.114, 0],
                    [47.457, -47.457],
                    [0, -67.116],
                    [-47.457, -47.457],
                    [-67.115, 0],
                    [-47.457, 47.458],
                    [0, 67.114],
                    [47.458, 47.458],
                  ],
                  o: [
                    [-67.115, 0],
                    [-47.457, 47.458],
                    [0, 67.114],
                    [47.458, 47.458],
                    [67.114, 0],
                    [47.458, -47.457],
                    [0, -67.116],
                    [-47.457, -47.457],
                  ],
                  v: [
                    [0, -251.263],
                    [-177.67, -177.67],
                    [-251.264, 0.001],
                    [-177.67, 177.67],
                    [0, 251.263],
                    [177.67, 177.67],
                    [251.264, 0.001],
                    [177.67, -177.67],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 1",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ind: 1,
              ty: "sh",
              ix: 2,
              ks: {
                a: 0,
                k: {
                  i: [
                    [53.867, 0],
                    [49.27, 20.84],
                    [36.644, 36.643],
                    [20.113, 47.554],
                    [0, 53.867],
                    [-20.84, 49.271],
                    [-36.644, 36.644],
                    [-47.553, 20.113],
                    [-53.868, 0],
                    [-49.271, -20.841],
                    [-36.644, -36.643],
                    [-20.113, -47.554],
                    [0, -53.868],
                    [20.84, -49.27],
                    [36.644, -36.645],
                    [47.553, -20.113],
                  ],
                  o: [
                    [-53.868, 0],
                    [-47.553, -20.113],
                    [-36.644, -36.645],
                    [-20.84, -49.27],
                    [0, -53.868],
                    [20.113, -47.554],
                    [36.644, -36.643],
                    [49.271, -20.841],
                    [53.867, 0],
                    [47.553, 20.113],
                    [36.644, 36.644],
                    [20.84, 49.27],
                    [0, 53.867],
                    [-20.113, 47.554],
                    [-36.644, 36.643],
                    [-49.271, 20.84],
                  ],
                  v: [
                    [0, 399.263],
                    [-155.434, 367.857],
                    [-282.322, 282.323],
                    [-367.857, 155.434],
                    [-399.264, 0.001],
                    [-367.857, -155.433],
                    [-282.322, -282.322],
                    [-155.434, -367.856],
                    [0, -399.263],
                    [155.434, -367.856],
                    [282.322, -282.322],
                    [367.857, -155.433],
                    [399.264, 0.001],
                    [367.857, 155.434],
                    [282.322, 282.323],
                    [155.434, 367.857],
                  ],
                  c: true,
                },
                ix: 2,
              },
              nm: "Path 2",
              mn: "ADBE Vector Shape - Group",
              hd: false,
            },
            {
              ty: "gr",
              it: [
                {
                  ty: "tr",
                  p: {a: 0, k: [0, 0], ix: 2},
                  a: {a: 0, k: [0, 0], ix: 1},
                  s: {a: 0, k: [100, 100], ix: 3},
                  r: {a: 0, k: 0, ix: 6},
                  o: {a: 0, k: 100, ix: 7},
                  sk: {a: 0, k: 0, ix: 4},
                  sa: {a: 0, k: 0, ix: 5},
                  nm: "Transform",
                },
              ],
              nm: "Group 1",
              np: 0,
              cix: 2,
              bm: 0,
              ix: 3,
              mn: "ADBE Vector Group",
              hd: false,
            },
            {
              ty: "fl",
              c: {
                a: 0,
                k: [0.780392216701, 0.866666726505, 0.921568687289, 1],
                ix: 4,
              },
              o: {a: 0, k: 100, ix: 5},
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: {a: 0, k: [399.514, 399.513], ix: 2},
              a: {a: 0, k: [0, 0], ix: 1},
              s: {a: 0, k: [100, 100], ix: 3},
              r: {a: 0, k: 0, ix: 6},
              o: {a: 0, k: 100, ix: 7},
              sk: {a: 0, k: 0, ix: 4},
              sa: {a: 0, k: 0, ix: 5},
              nm: "Transform",
            },
          ],
          nm: "Group 1",
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 720.001312347504,
      st: 0,
      ct: 1,
      bm: 0,
    },
  ],
  markers: [],
  props: {},
  chars: [
    {
      ch: "P",
      size: 21,
      style: "Bold",
      w: 61.38,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-3.109, 0.847],
                      [-2.23, 1.384],
                      [-1.433, 1.742],
                      [-0.814, 1.807],
                      [-0.326, 1.693],
                      [0, 1.27],
                      [1.139, 2.767],
                      [2.344, 2.002],
                      [3.564, 1.14],
                      [4.85, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [4.199, 0],
                      [3.108, -0.846],
                      [2.229, -1.383],
                      [1.432, -1.741],
                      [0.813, -1.807],
                      [0.325, -1.692],
                      [0, -3.255],
                      [-1.14, -2.766],
                      [-2.344, -2.002],
                      [-3.564, -1.139],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [27.441, -29.59],
                      [38.403, -30.859],
                      [46.411, -34.204],
                      [51.904, -38.892],
                      [55.273, -44.214],
                      [56.982, -49.463],
                      [57.471, -53.906],
                      [55.762, -62.939],
                      [50.537, -70.093],
                      [41.675, -74.805],
                      [29.053, -76.514],
                      [7.324, -76.514],
                      [7.324, 0],
                      [20.752, 0],
                      [20.752, -29.59],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "P",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [-2.068, -0.7],
                      [-1.27, -1.188],
                      [-0.554, -1.579],
                      [0, -1.79],
                      [0.797, -1.758],
                      [1.465, -1.204],
                      [2.051, -0.618],
                      [2.473, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [3.059, 0],
                      [2.067, 0.7],
                      [1.27, 1.189],
                      [0.553, 1.579],
                      [0, 2.246],
                      [-0.798, 1.758],
                      [-1.465, 1.205],
                      [-2.051, 0.619],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [20.752, -66.65],
                      [27.93, -66.65],
                      [35.62, -65.601],
                      [40.625, -62.769],
                      [43.359, -58.618],
                      [44.189, -53.564],
                      [42.993, -47.559],
                      [39.6, -43.115],
                      [34.326, -40.381],
                      [27.539, -39.453],
                      [20.752, -39.404],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "P",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "P",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "e",
      size: 21,
      style: "Bold",
      w: 59.72,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [1.025, -0.96],
                      [1.123, -0.586],
                      [1.318, -0.26],
                      [1.758, 0],
                      [1.562, 1.074],
                      [1.057, 1.611],
                      [0.553, 1.823],
                      [0, 1.53],
                      [0, 0],
                      [-0.082, 1.351],
                      [0, 1.27],
                      [0.944, 2.686],
                      [1.871, 1.888],
                      [2.799, 1.009],
                      [3.711, 0],
                      [3.076, -1.465],
                      [2.034, -2.441],
                      [0.993, -3.206],
                      [0, -3.516],
                      [-0.961, -3.385],
                      [-2.035, -2.604],
                      [-3.207, -1.562],
                      [-4.492, 0],
                      [-1.921, 0.227],
                      [-1.855, 0.7],
                      [-1.872, 1.302],
                      [-2.019, 2.148],
                    ],
                    o: [
                      [-1.172, 1.433],
                      [-1.025, 0.961],
                      [-1.123, 0.586],
                      [-1.318, 0.261],
                      [-2.019, 0],
                      [-1.562, -1.074],
                      [-1.058, -1.611],
                      [-0.554, -1.823],
                      [0, 0],
                      [0.26, -1.465],
                      [0.081, -1.35],
                      [0, -3.32],
                      [-0.945, -2.686],
                      [-1.872, -1.888],
                      [-2.8, -1.009],
                      [-4.167, 0],
                      [-3.076, 1.465],
                      [-2.035, 2.441],
                      [-0.993, 3.207],
                      [0, 3.646],
                      [0.96, 3.386],
                      [2.034, 2.605],
                      [3.206, 1.562],
                      [2.083, 0],
                      [1.92, -0.228],
                      [1.855, -0.7],
                      [1.871, -1.302],
                      [0, 0],
                    ],
                    v: [
                      [46.533, -15.43],
                      [43.237, -11.841],
                      [40.015, -9.521],
                      [36.353, -8.252],
                      [31.738, -7.861],
                      [26.367, -9.473],
                      [22.437, -13.501],
                      [20.02, -18.652],
                      [19.189, -23.682],
                      [52.148, -23.682],
                      [52.661, -27.905],
                      [52.783, -31.836],
                      [51.367, -40.845],
                      [47.144, -47.705],
                      [40.137, -52.051],
                      [30.371, -53.564],
                      [19.507, -51.367],
                      [11.841, -45.508],
                      [7.3, -37.036],
                      [5.811, -26.953],
                      [7.251, -16.406],
                      [11.743, -7.422],
                      [19.604, -1.172],
                      [31.152, 1.172],
                      [37.158, 0.83],
                      [42.822, -0.562],
                      [48.413, -3.564],
                      [54.248, -8.74],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "e",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-1.286, -0.797],
                      [-0.684, -1.221],
                      [-0.195, -1.481],
                      [0, -1.367],
                      [0, 0],
                      [-0.326, 1.498],
                      [-0.781, 1.172],
                      [-1.335, 0.716],
                      [-2.051, 0],
                    ],
                    o: [
                      [1.286, 0.798],
                      [0.684, 1.221],
                      [0.195, 1.482],
                      [0, 0],
                      [0, -1.595],
                      [0.325, -1.497],
                      [0.781, -1.172],
                      [1.334, -0.716],
                      [2.18, 0],
                    ],
                    v: [
                      [34.839, -42.847],
                      [37.793, -39.819],
                      [39.111, -35.767],
                      [39.404, -31.494],
                      [19.238, -31.494],
                      [19.727, -36.133],
                      [21.387, -40.137],
                      [24.561, -42.969],
                      [29.639, -44.043],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "e",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "e",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "r",
      size: 21,
      style: "Bold",
      w: 43.16,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-0.049, -0.764],
                      [-0.017, -0.879],
                      [-0.017, -0.846],
                      [0, -0.553],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-2.165, 1.433],
                      [-3.027, 0],
                      [-0.896, -0.179],
                      [-1.042, -0.488],
                      [0, 0],
                      [0.879, 0.228],
                      [1.79, 0],
                      [1.579, -0.651],
                      [1.432, -1.057],
                      [1.172, -1.367],
                      [0.618, -1.432],
                      [0.684, 3.451],
                    ],
                    o: [
                      [0.065, 0.391],
                      [0.049, 0.765],
                      [0.016, 0.879],
                      [0.016, 0.847],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.367, -2.344],
                      [2.164, -1.432],
                      [0.879, 0],
                      [0.895, 0.179],
                      [0, 0],
                      [-0.521, -0.227],
                      [-0.879, -0.227],
                      [-1.433, 0],
                      [-1.579, 0.652],
                      [-1.433, 1.058],
                      [-1.172, 1.367],
                      [-0.293, -3.58],
                      [0, 0],
                    ],
                    v: [
                      [7.666, -52.734],
                      [7.837, -51.001],
                      [7.935, -48.535],
                      [7.983, -45.947],
                      [8.008, -43.848],
                      [8.008, 0],
                      [20.801, 0],
                      [20.703, -34.521],
                      [26.001, -40.186],
                      [33.789, -42.334],
                      [36.45, -42.065],
                      [39.355, -41.064],
                      [42.09, -52.539],
                      [39.99, -53.223],
                      [35.986, -53.564],
                      [31.47, -52.588],
                      [26.953, -50.024],
                      [23.047, -46.387],
                      [20.361, -42.188],
                      [18.896, -52.734],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "r",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "r",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "f",
      size: 21,
      style: "Bold",
      w: 37.6,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.098, 0.668],
                      [0.146, 0.863],
                      [0.179, 0.928],
                      [0.146, 0.847],
                      [0.098, 0.652],
                      [0, 0.261],
                      [-1.221, 0.359],
                      [-2.019, 0],
                      [-0.863, -0.227],
                      [-0.7, -0.342],
                      [-0.57, -0.391],
                      [-0.456, -0.358],
                      [0, 0],
                      [1.155, 0.423],
                      [1.302, 0.293],
                      [1.302, 0.163],
                      [1.074, 0],
                      [2.132, -0.764],
                      [1.53, -1.643],
                      [0.862, -2.571],
                      [0, -3.613],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -0.293],
                      [-0.098, -0.667],
                      [-0.146, -0.862],
                      [-0.179, -0.928],
                      [-0.146, -0.846],
                      [-0.098, -0.651],
                      [0, -0.748],
                      [1.221, -0.358],
                      [1.009, 0],
                      [0.862, 0.228],
                      [0.7, 0.342],
                      [0.569, 0.391],
                      [0, 0],
                      [-0.847, -0.52],
                      [-1.156, -0.423],
                      [-1.302, -0.293],
                      [-1.302, -0.163],
                      [-2.539, 0],
                      [-2.132, 0.765],
                      [-1.53, 1.644],
                      [-0.863, 2.572],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.686, -50.244],
                      [2.686, -43.652],
                      [9.814, -43.652],
                      [9.814, 0],
                      [22.51, 0],
                      [22.51, -43.652],
                      [33.008, -43.652],
                      [33.74, -52.734],
                      [22.51, -52.734],
                      [22.363, -54.175],
                      [21.997, -56.47],
                      [21.509, -59.155],
                      [21.021, -61.816],
                      [20.654, -64.062],
                      [20.508, -65.43],
                      [22.339, -67.09],
                      [27.197, -67.627],
                      [30.005, -67.285],
                      [32.349, -66.431],
                      [34.253, -65.332],
                      [35.791, -64.209],
                      [41.357, -73.779],
                      [38.354, -75.195],
                      [34.668, -76.27],
                      [30.762, -76.953],
                      [27.197, -77.197],
                      [20.19, -76.05],
                      [14.697, -72.437],
                      [11.108, -66.113],
                      [9.814, -56.836],
                      [9.814, -52.734],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "f",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "f",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "o",
      size: 21,
      style: "Bold",
      w: 63.57,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-3.142, 1.432],
                      [-2.197, 2.474],
                      [-1.156, 3.304],
                      [0, 3.744],
                      [0.993, 3.369],
                      [2.083, 2.49],
                      [3.223, 1.433],
                      [4.459, 0],
                      [3.304, -1.432],
                      [2.18, -2.441],
                      [1.074, -3.223],
                      [0, -3.613],
                      [-1.156, -3.467],
                      [-2.246, -2.457],
                      [-3.304, -1.334],
                      [-4.297, 0],
                    ],
                    o: [
                      [3.141, -1.432],
                      [2.197, -2.473],
                      [1.155, -3.304],
                      [0, -3.841],
                      [-0.993, -3.369],
                      [-2.084, -2.49],
                      [-3.223, -1.432],
                      [-4.46, 0],
                      [-3.304, 1.433],
                      [-2.181, 2.441],
                      [-1.074, 3.223],
                      [0, 4.265],
                      [1.155, 3.467],
                      [2.246, 2.458],
                      [3.304, 1.334],
                      [3.938, 0],
                    ],
                    v: [
                      [42.993, -0.83],
                      [51.001, -6.689],
                      [56.03, -15.356],
                      [57.764, -25.928],
                      [56.274, -36.743],
                      [51.66, -45.532],
                      [43.701, -51.416],
                      [32.178, -53.564],
                      [20.532, -51.416],
                      [12.305, -45.605],
                      [7.422, -37.109],
                      [5.811, -26.855],
                      [7.544, -15.259],
                      [12.646, -6.372],
                      [20.972, -0.684],
                      [32.373, 1.318],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "o",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [1.611, 1.156],
                      [1.025, 1.823],
                      [0.471, 2.214],
                      [0, 2.148],
                      [-0.537, 2.263],
                      [-1.042, 1.644],
                      [-1.579, 0.945],
                      [-2.051, 0],
                      [-1.595, -0.911],
                      [-1.009, -1.546],
                      [-0.439, -2.067],
                      [0, -2.311],
                      [0.488, -2.409],
                      [1.009, -1.92],
                      [1.562, -1.172],
                      [2.148, 0],
                    ],
                    o: [
                      [-1.611, -1.155],
                      [-1.025, -1.823],
                      [-0.472, -2.213],
                      [0, -2.637],
                      [0.537, -2.262],
                      [1.041, -1.643],
                      [1.579, -0.944],
                      [2.278, 0],
                      [1.595, 0.912],
                      [1.009, 1.546],
                      [0.439, 2.068],
                      [0, 2.507],
                      [-0.488, 2.409],
                      [-1.009, 1.921],
                      [-1.562, 1.172],
                      [-2.246, 0],
                    ],
                    v: [
                      [26.147, -9.204],
                      [22.192, -13.672],
                      [19.946, -19.727],
                      [19.238, -26.27],
                      [20.044, -33.618],
                      [22.412, -39.478],
                      [26.343, -43.359],
                      [31.787, -44.775],
                      [37.598, -43.408],
                      [41.504, -39.722],
                      [43.677, -34.302],
                      [44.336, -27.734],
                      [43.604, -20.361],
                      [41.357, -13.867],
                      [37.5, -9.229],
                      [31.934, -7.471],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "o",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "o",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "m",
      size: 21,
      style: "Bold",
      w: 90.14,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-0.033, -1.106],
                      [0, -1.106],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-1.482, 0.472],
                      [-1.953, 0],
                      [-1.107, -0.293],
                      [-0.749, -0.748],
                      [-0.375, -1.302],
                      [0, -2.018],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.13, 0.961],
                      [0.26, 0.749],
                      [-1.482, 0.326],
                      [-1.562, 0],
                      [-1.107, -0.309],
                      [-0.765, -0.764],
                      [-0.407, -1.286],
                      [0, -1.985],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.602, 1.97],
                      [1.286, 1.449],
                      [2.018, 0.83],
                      [2.832, 0],
                      [1.465, -0.195],
                      [1.399, -0.439],
                      [1.399, -0.7],
                      [1.497, -1.009],
                      [2.278, 1.025],
                      [2.897, 0],
                      [1.546, -0.325],
                      [1.383, -0.537],
                      [1.188, -0.667],
                      [0.813, -0.716],
                      [0.227, 0.961],
                      [0.195, 0.521],
                    ],
                    o: [
                      [0.163, 0.781],
                      [0.032, 1.107],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.465, -0.846],
                      [1.481, -0.471],
                      [1.497, 0],
                      [1.106, 0.293],
                      [0.748, 0.749],
                      [0.374, 1.302],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -1.27],
                      [-0.13, -0.96],
                      [1.725, -0.781],
                      [1.481, -0.325],
                      [1.399, 0],
                      [1.106, 0.31],
                      [0.764, 0.765],
                      [0.407, 1.286],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -2.246],
                      [-0.603, -1.969],
                      [-1.286, -1.448],
                      [-2.019, -0.83],
                      [-1.66, 0],
                      [-1.465, 0.195],
                      [-1.4, 0.439],
                      [-1.4, 0.7],
                      [-1.237, -1.627],
                      [-2.279, -1.025],
                      [-1.53, 0],
                      [-1.546, 0.326],
                      [-1.384, 0.537],
                      [-1.189, 0.668],
                      [-0.13, -0.781],
                      [-0.228, -0.96],
                      [0, 0],
                    ],
                    v: [
                      [7.91, -52.734],
                      [8.203, -49.902],
                      [8.252, -46.582],
                      [8.252, 0],
                      [20.947, 0],
                      [20.947, -41.309],
                      [25.366, -43.286],
                      [30.518, -43.994],
                      [34.424, -43.555],
                      [37.207, -41.992],
                      [38.892, -38.916],
                      [39.453, -33.936],
                      [39.453, 0],
                      [52.148, 0],
                      [52.148, -35.938],
                      [51.953, -39.282],
                      [51.367, -41.846],
                      [56.177, -43.506],
                      [60.742, -43.994],
                      [64.502, -43.53],
                      [67.31, -41.919],
                      [69.067, -38.843],
                      [69.678, -33.936],
                      [69.678, 0],
                      [82.373, 0],
                      [82.373, -37.451],
                      [81.47, -43.774],
                      [78.638, -48.901],
                      [73.682, -52.319],
                      [66.406, -53.564],
                      [61.719, -53.271],
                      [57.422, -52.319],
                      [53.223, -50.61],
                      [48.877, -48.047],
                      [43.604, -52.026],
                      [35.84, -53.564],
                      [31.226, -53.076],
                      [26.831, -51.782],
                      [22.974, -49.976],
                      [19.971, -47.9],
                      [19.434, -50.513],
                      [18.799, -52.734],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "m",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "m",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "a",
      size: 21,
      style: "Bold",
      w: 60.06,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-1.205, 0.896],
                      [-1.123, 0.537],
                      [-1.107, 0.212],
                      [-1.237, 0],
                      [-1.205, -0.374],
                      [-0.863, -0.781],
                      [-0.488, -1.237],
                      [0, -1.725],
                      [0, 0],
                      [2.669, -0.227],
                      [2.393, -0.553],
                      [2.018, -0.96],
                      [1.465, -1.465],
                      [0.83, -2.034],
                      [0, -2.702],
                      [-0.716, -1.807],
                      [-1.335, -1.221],
                      [-1.888, -0.618],
                      [-2.377, 0],
                      [-1.482, 0.195],
                      [-1.482, 0.488],
                      [-1.465, 0.847],
                      [-1.367, 1.27],
                      [-1.644, -1.123],
                      [-2.441, 0],
                      [-1.091, 0.195],
                      [-0.928, 0.309],
                      [-0.814, 0.423],
                      [-0.781, 0.488],
                      [0, 0],
                      [0.716, -0.098],
                      [0.26, 0],
                      [0.488, 0.179],
                      [0.309, 0.439],
                      [0.13, 0.765],
                      [0, 1.14],
                      [0, 0],
                      [1.204, 2.1],
                      [2.018, 1.335],
                      [2.604, 0.652],
                      [2.832, 0],
                      [3.809, -1.416],
                      [2.766, -2.506],
                    ],
                    o: [
                      [1.465, -1.399],
                      [1.204, -0.895],
                      [1.123, -0.537],
                      [1.106, -0.211],
                      [1.465, 0],
                      [1.204, 0.375],
                      [0.862, 0.781],
                      [0.488, 1.237],
                      [0, 0],
                      [-2.767, 0],
                      [-2.67, 0.228],
                      [-2.393, 0.554],
                      [-2.019, 0.961],
                      [-1.465, 1.465],
                      [-0.83, 2.035],
                      [0, 2.409],
                      [0.716, 1.807],
                      [1.334, 1.221],
                      [1.888, 0.618],
                      [1.399, 0],
                      [1.481, -0.195],
                      [1.481, -0.488],
                      [1.465, -0.846],
                      [0.455, 2.084],
                      [1.643, 1.123],
                      [1.302, 0],
                      [1.09, -0.195],
                      [0.928, -0.309],
                      [0.813, -0.423],
                      [0, 0],
                      [-0.652, 0.13],
                      [-0.716, 0.098],
                      [-0.716, 0],
                      [-0.488, -0.179],
                      [-0.31, -0.439],
                      [-0.13, -0.764],
                      [0, 0],
                      [0, -2.864],
                      [-1.205, -2.1],
                      [-2.019, -1.334],
                      [-2.605, -0.651],
                      [-4.199, 0],
                      [-3.809, 1.416],
                      [0, 0],
                    ],
                    v: [
                      [12.939, -37.939],
                      [16.943, -41.382],
                      [20.435, -43.53],
                      [23.779, -44.653],
                      [27.295, -44.971],
                      [31.299, -44.409],
                      [34.399, -42.676],
                      [36.426, -39.648],
                      [37.158, -35.205],
                      [37.158, -33.301],
                      [29.004, -32.959],
                      [21.411, -31.787],
                      [14.795, -29.517],
                      [9.57, -25.879],
                      [6.128, -20.63],
                      [4.883, -13.525],
                      [5.957, -7.202],
                      [9.033, -2.661],
                      [13.867, 0.098],
                      [20.264, 1.025],
                      [24.585, 0.732],
                      [29.028, -0.293],
                      [33.447, -2.295],
                      [37.695, -5.469],
                      [40.845, -0.659],
                      [46.973, 1.025],
                      [50.562, 0.732],
                      [53.589, -0.024],
                      [56.201, -1.123],
                      [58.594, -2.49],
                      [57.227, -8.105],
                      [55.176, -7.764],
                      [53.711, -7.617],
                      [51.904, -7.886],
                      [50.708, -8.813],
                      [50.049, -10.62],
                      [49.854, -13.477],
                      [49.854, -37.012],
                      [48.047, -44.458],
                      [43.213, -49.609],
                      [36.279, -52.588],
                      [28.125, -53.564],
                      [16.113, -51.44],
                      [6.25, -45.557],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "a",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [1.041, -0.488],
                      [1.009, -0.276],
                      [0.96, -0.098],
                      [0.911, 0],
                      [0.846, 0.244],
                      [0.602, 0.586],
                      [0.325, 0.945],
                      [0, 1.433],
                      [-0.554, 1.416],
                      [-1.416, 1.058],
                      [-2.425, 0.652],
                      [-3.777, 0.163],
                    ],
                    o: [
                      [-1.074, 0.749],
                      [-1.042, 0.488],
                      [-1.009, 0.277],
                      [-0.961, 0.098],
                      [-1.009, 0],
                      [-0.847, -0.244],
                      [-0.603, -0.586],
                      [-0.326, -0.944],
                      [0, -1.692],
                      [0.553, -1.416],
                      [1.416, -1.057],
                      [2.425, -0.651],
                      [0, 0],
                    ],
                    v: [
                      [37.158, -11.621],
                      [33.984, -9.766],
                      [30.908, -8.618],
                      [27.954, -8.057],
                      [25.146, -7.91],
                      [22.363, -8.276],
                      [20.19, -9.521],
                      [18.799, -11.816],
                      [18.311, -15.381],
                      [19.141, -20.044],
                      [22.095, -23.755],
                      [27.856, -26.318],
                      [37.158, -27.539],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "a",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "a",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "n",
      size: 21,
      style: "Bold",
      w: 63.67,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-1.058, 0.391],
                      [-1.091, 0.293],
                      [-1.042, 0.146],
                      [-0.912, 0],
                      [-1.205, -0.407],
                      [-0.83, -0.895],
                      [-0.423, -1.465],
                      [0, -2.116],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.009, 2.312],
                      [1.741, 1.595],
                      [2.36, 0.847],
                      [2.734, 0],
                      [1.53, -0.342],
                      [1.318, -0.569],
                      [1.106, -0.716],
                      [0.781, -0.716],
                      [0.081, 0.505],
                      [0.114, 0.472],
                      [0.098, 0.407],
                      [0.098, 0.228],
                      [0, 0],
                      [-0.049, -1.643],
                      [0, -1.041],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0.911, -0.488],
                      [1.057, -0.391],
                      [1.09, -0.293],
                      [1.041, -0.146],
                      [1.562, 0],
                      [1.204, 0.407],
                      [0.83, 0.896],
                      [0.423, 1.465],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -2.93],
                      [-1.009, -2.311],
                      [-1.742, -1.595],
                      [-2.361, -0.846],
                      [-1.66, 0],
                      [-1.53, 0.342],
                      [-1.318, 0.57],
                      [-1.107, 0.716],
                      [-0.066, -0.423],
                      [-0.082, -0.504],
                      [-0.114, -0.471],
                      [-0.098, -0.407],
                      [0, 0],
                      [0.325, 1.693],
                      [0.049, 1.644],
                      [0, 0],
                    ],
                    v: [
                      [8.447, 0],
                      [21.143, 0],
                      [21.143, -40.771],
                      [24.097, -42.09],
                      [27.319, -43.115],
                      [30.518, -43.774],
                      [33.447, -43.994],
                      [37.598, -43.384],
                      [40.649, -41.431],
                      [42.529, -37.891],
                      [43.164, -32.52],
                      [43.164, 0],
                      [55.859, 0],
                      [55.859, -34.912],
                      [54.346, -42.773],
                      [50.22, -48.633],
                      [44.067, -52.295],
                      [36.426, -53.564],
                      [31.641, -53.052],
                      [27.368, -51.685],
                      [23.73, -49.756],
                      [20.898, -47.607],
                      [20.679, -48.999],
                      [20.386, -50.464],
                      [20.068, -51.782],
                      [19.775, -52.734],
                      [7.812, -52.734],
                      [8.374, -47.729],
                      [8.447, -43.701],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "n",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "n",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "c",
      size: 21,
      style: "Bold",
      w: 57.03,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0.96, -0.944],
                      [0.977, -0.537],
                      [1.025, -0.195],
                      [1.106, 0],
                      [1.692, 0.977],
                      [1.106, 1.709],
                      [0.52, 2.312],
                      [0, 2.637],
                      [-0.505, 2.051],
                      [-1.091, 1.66],
                      [-1.677, 1.042],
                      [-2.344, 0],
                      [-0.961, -0.195],
                      [-0.879, -0.439],
                      [-0.814, -0.684],
                      [-0.945, -0.977],
                      [0, 0],
                      [1.416, 0.814],
                      [1.546, 0.472],
                      [1.66, 0.163],
                      [1.79, 0],
                      [3.401, -1.383],
                      [2.278, -2.457],
                      [1.172, -3.352],
                      [0, -3.938],
                      [-0.961, -3.206],
                      [-2.1, -2.506],
                      [-3.304, -1.53],
                      [-4.688, 0],
                      [-1.937, 0.227],
                      [-1.823, 0.7],
                      [-1.66, 1.27],
                      [-1.465, 2.084],
                    ],
                    o: [
                      [-1.009, 1.498],
                      [-0.961, 0.945],
                      [-0.977, 0.537],
                      [-1.025, 0.195],
                      [-2.344, 0],
                      [-1.693, -0.977],
                      [-1.107, -1.709],
                      [-0.521, -2.311],
                      [0, -2.018],
                      [0.504, -2.051],
                      [1.09, -1.66],
                      [1.676, -1.041],
                      [1.204, 0],
                      [0.96, 0.195],
                      [0.879, 0.439],
                      [0.813, 0.684],
                      [0, 0],
                      [-1.302, -1.302],
                      [-1.416, -0.813],
                      [-1.546, -0.471],
                      [-1.66, -0.163],
                      [-4.492, 0],
                      [-3.402, 1.384],
                      [-2.279, 2.458],
                      [-1.172, 3.353],
                      [0, 3.353],
                      [0.96, 3.207],
                      [2.1, 2.507],
                      [3.304, 1.53],
                      [1.985, 0],
                      [1.936, -0.228],
                      [1.823, -0.7],
                      [1.66, -1.27],
                      [0, 0],
                    ],
                    v: [
                      [44.678, -15.576],
                      [41.724, -11.914],
                      [38.818, -9.692],
                      [35.815, -8.594],
                      [32.617, -8.301],
                      [26.562, -9.766],
                      [22.363, -13.794],
                      [19.922, -19.824],
                      [19.141, -27.246],
                      [19.897, -33.35],
                      [22.29, -38.916],
                      [26.44, -42.969],
                      [32.471, -44.531],
                      [35.718, -44.238],
                      [38.477, -43.286],
                      [41.016, -41.602],
                      [43.652, -39.111],
                      [51.562, -47.266],
                      [47.485, -50.439],
                      [43.042, -52.368],
                      [38.232, -53.32],
                      [33.057, -53.564],
                      [21.216, -51.489],
                      [12.695, -45.728],
                      [7.52, -37.012],
                      [5.762, -26.074],
                      [7.202, -16.235],
                      [11.792, -7.666],
                      [19.897, -1.611],
                      [31.885, 0.684],
                      [37.769, 0.342],
                      [43.408, -1.05],
                      [48.633, -4.004],
                      [53.32, -9.033],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "c",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "c",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: ".",
      size: 21,
      style: "Bold",
      w: 23.44,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-0.359, -0.846],
                      [-0.619, -0.635],
                      [-0.83, -0.358],
                      [-0.912, 0],
                      [-0.814, 0.358],
                      [-0.619, 0.635],
                      [-0.342, 0.847],
                      [0, 0.977],
                      [0.342, 0.847],
                      [0.618, 0.635],
                      [0.813, 0.359],
                      [0.911, 0],
                      [0.83, -0.358],
                      [0.618, -0.635],
                      [0.358, -0.846],
                      [0, -0.977],
                    ],
                    o: [
                      [0.358, 0.847],
                      [0.618, 0.635],
                      [0.83, 0.358],
                      [0.911, 0],
                      [0.813, -0.358],
                      [0.618, -0.635],
                      [0.342, -0.846],
                      [0, -0.977],
                      [-0.342, -0.846],
                      [-0.619, -0.635],
                      [-0.814, -0.358],
                      [-0.912, 0],
                      [-0.83, 0.359],
                      [-0.619, 0.635],
                      [-0.359, 0.847],
                      [0, 0.977],
                    ],
                    v: [
                      [5.859, -3.564],
                      [7.324, -1.343],
                      [9.497, 0.146],
                      [12.109, 0.684],
                      [14.697, 0.146],
                      [16.846, -1.343],
                      [18.286, -3.564],
                      [18.799, -6.299],
                      [18.286, -9.033],
                      [16.846, -11.255],
                      [14.697, -12.744],
                      [12.109, -13.281],
                      [9.497, -12.744],
                      [7.324, -11.255],
                      [5.859, -9.033],
                      [5.322, -6.299],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: ".",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: ".",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "H",
      size: 21,
      style: "Bold",
      w: 73.19,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [7.324, 0],
                      [20.752, 0],
                      [20.752, -33.301],
                      [52.441, -33.301],
                      [52.441, 0],
                      [65.869, 0],
                      [65.869, -76.514],
                      [52.441, -76.514],
                      [52.441, -43.164],
                      [20.752, -43.164],
                      [20.752, -76.514],
                      [7.324, -76.514],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "H",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "H",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "u",
      size: 21,
      style: "Bold",
      w: 63.33,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [-0.586, -2.246],
                      [-1.4, -1.66],
                      [-2.328, -0.96],
                      [-3.516, 0],
                      [-1.53, 0.325],
                      [-1.514, 0.603],
                      [-1.384, 0.83],
                      [-1.107, 0.977],
                      [-0.13, -0.553],
                      [-0.146, -0.618],
                      [-0.146, -0.537],
                      [-0.066, -0.195],
                      [0, 0],
                      [0.195, 1.579],
                      [0, 0.847],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [2.571, -0.602],
                      [2.409, 0],
                      [0.928, 0.293],
                      [0.684, 0.635],
                      [0.407, 1.009],
                      [0, 1.4],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 2.572],
                      [0.586, 2.246],
                      [1.399, 1.66],
                      [2.327, 0.96],
                      [1.399, 0],
                      [1.53, -0.326],
                      [1.514, -0.602],
                      [1.383, -0.83],
                      [0.032, 0.261],
                      [0.13, 0.554],
                      [0.146, 0.619],
                      [0.146, 0.537],
                      [0, 0],
                      [-0.391, -2.116],
                      [-0.195, -1.579],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-2.084, 1.27],
                      [-2.572, 0.603],
                      [-1.074, 0],
                      [-0.928, -0.293],
                      [-0.684, -0.635],
                      [-0.407, -1.009],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [7.324, -52.734],
                      [7.324, -17.529],
                      [8.203, -10.303],
                      [11.182, -4.443],
                      [16.772, -0.513],
                      [25.537, 0.928],
                      [29.932, 0.439],
                      [34.497, -0.952],
                      [38.843, -3.101],
                      [42.578, -5.811],
                      [42.822, -4.59],
                      [43.237, -2.832],
                      [43.677, -1.099],
                      [43.994, 0],
                      [56.006, 0],
                      [55.127, -5.542],
                      [54.834, -9.18],
                      [54.834, -52.734],
                      [42.139, -52.734],
                      [42.139, -12.402],
                      [35.156, -9.595],
                      [27.686, -8.691],
                      [24.683, -9.131],
                      [22.266, -10.522],
                      [20.63, -12.988],
                      [20.02, -16.602],
                      [20.02, -52.734],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "u",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "u",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "b",
      size: 21,
      style: "Bold",
      w: 63.62,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-1.872, -0.179],
                      [-1.904, -0.098],
                      [-2.051, -0.049],
                      [-2.441, 0],
                      [-3.076, 1.106],
                      [-2.441, 2.295],
                      [-1.514, 3.484],
                      [0, 4.753],
                      [0.83, 3.239],
                      [1.79, 2.458],
                      [2.815, 1.482],
                      [4.004, 0],
                      [2.588, -0.895],
                      [1.79, -1.399],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [2.051, 0.293],
                      [1.871, 0.179],
                      [1.904, 0.098],
                      [2.051, 0.049],
                      [3.157, 0],
                      [3.076, -1.106],
                      [2.441, -2.295],
                      [1.514, -3.483],
                      [0, -3.516],
                      [-0.83, -3.239],
                      [-1.791, -2.457],
                      [-2.816, -1.481],
                      [-3.06, 0],
                      [-2.588, 0.896],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [7.812, -0.391],
                      [13.696, 0.317],
                      [19.36, 0.732],
                      [25.293, 0.952],
                      [32.031, 1.025],
                      [41.382, -0.635],
                      [49.658, -5.737],
                      [55.591, -14.404],
                      [57.861, -26.758],
                      [56.616, -36.89],
                      [52.686, -45.435],
                      [45.776, -51.343],
                      [35.547, -53.564],
                      [27.075, -52.222],
                      [20.508, -48.779],
                      [20.508, -76.514],
                      [7.812, -76.514],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "b",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-0.863, 0.326],
                      [-0.977, 0.244],
                      [-1.058, 0.146],
                      [-1.042, 0],
                      [-1.611, -0.813],
                      [-1.042, -1.497],
                      [-0.488, -2.1],
                      [0, -2.571],
                      [0.667, -2.49],
                      [1.204, -1.741],
                      [1.66, -0.911],
                      [1.985, 0],
                      [1.807, 0.31],
                      [1.367, 0.488],
                    ],
                    o: [
                      [0.618, -0.391],
                      [0.862, -0.325],
                      [0.977, -0.244],
                      [1.057, -0.146],
                      [2.246, 0],
                      [1.611, 0.814],
                      [1.041, 1.498],
                      [0.488, 2.1],
                      [0, 3.158],
                      [-0.668, 2.49],
                      [-1.205, 1.742],
                      [-1.66, 0.912],
                      [-1.953, 0],
                      [-1.807, -0.309],
                      [0, 0],
                    ],
                    v: [
                      [20.508, -41.211],
                      [22.729, -42.285],
                      [25.488, -43.14],
                      [28.54, -43.726],
                      [31.689, -43.945],
                      [37.476, -42.725],
                      [41.455, -39.258],
                      [43.75, -33.862],
                      [44.482, -26.855],
                      [43.481, -18.384],
                      [40.674, -12.036],
                      [36.377, -8.057],
                      [30.908, -6.689],
                      [25.269, -7.153],
                      [20.508, -8.35],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "b",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "b",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "l",
      size: 21,
      style: "Bold",
      w: 30.81,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-0.619, -1.465],
                      [-1.009, -0.83],
                      [-1.302, -0.293],
                      [-1.4, 0],
                      [-1.123, 0.227],
                      [-1.058, 0.374],
                      [-0.961, 0.488],
                      [-0.814, 0.554],
                      [0, 0],
                      [0.748, -0.293],
                      [1.074, 0],
                      [0.537, 0.684],
                      [0, 1.66],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 2.312],
                      [0.618, 1.465],
                      [1.009, 0.83],
                      [1.302, 0.293],
                      [1.106, 0],
                      [1.123, -0.228],
                      [1.057, -0.374],
                      [0.96, -0.488],
                      [0, 0],
                      [-0.977, 0.391],
                      [-0.749, 0.293],
                      [-0.945, 0],
                      [-0.537, -0.684],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [7.324, -10.254],
                      [8.252, -4.59],
                      [10.693, -1.147],
                      [14.16, 0.537],
                      [18.213, 0.977],
                      [21.558, 0.635],
                      [24.829, -0.269],
                      [27.856, -1.562],
                      [30.518, -3.125],
                      [28.369, -9.668],
                      [25.781, -8.643],
                      [23.047, -8.203],
                      [20.825, -9.229],
                      [20.02, -12.744],
                      [20.02, -76.514],
                      [7.324, -76.514],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "l",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "l",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "g",
      size: 21,
      style: "Bold",
      w: 58.15,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [2.539, -0.309],
                      [2.799, -0.846],
                      [0.96, 0.375],
                      [0.96, 0.261],
                      [1.09, 0.13],
                      [1.399, 0],
                      [2.686, -0.797],
                      [1.936, -1.546],
                      [1.09, -2.213],
                      [0, -2.93],
                      [-0.261, -1.367],
                      [-0.586, -1.188],
                      [-0.912, -1.041],
                      [-1.335, -0.977],
                      [1.057, -0.651],
                      [0.781, -0.813],
                      [0.439, -0.977],
                      [0, -1.139],
                      [-0.652, -1.106],
                      [-0.928, -0.748],
                      [-0.993, -0.471],
                      [-0.684, -0.391],
                      [1.253, -0.83],
                      [0.977, -1.091],
                      [0.602, -1.367],
                      [0, -1.791],
                      [-0.863, -1.302],
                      [-1.791, -0.945],
                      [-2.767, -0.521],
                      [-3.777, 0],
                      [-2.23, 0.163],
                      [-2.132, 0.471],
                      [-1.921, 0.797],
                      [-1.449, 1.286],
                      [-0.863, 1.79],
                      [0, 2.441],
                      [0.651, 1.318],
                      [1.139, 0.945],
                      [1.497, 0.619],
                      [1.692, 0.423],
                      [1.774, 0.293],
                      [1.692, 0.293],
                      [1.188, 0.212],
                      [1.204, 0.244],
                      [1.139, 0.31],
                      [0.862, 0.359],
                      [0.537, 0.391],
                      [0, 0.456],
                      [-0.521, 0.765],
                      [-0.652, 0.554],
                      [-1.872, -0.374],
                      [-2.898, 0],
                      [-2.23, 0.814],
                      [-1.872, 1.546],
                      [-1.205, 2.246],
                      [0, 2.865],
                      [0.618, 1.791],
                      [0.813, 0.977],
                    ],
                    o: [
                      [0, 0],
                      [-2.246, 0],
                      [-2.539, 0.31],
                      [-1.205, -0.52],
                      [-0.961, -0.374],
                      [-0.961, -0.26],
                      [-1.091, -0.13],
                      [-3.191, 0],
                      [-2.686, 0.798],
                      [-1.937, 1.546],
                      [-1.091, 2.214],
                      [0, 1.66],
                      [0.26, 1.367],
                      [0.586, 1.189],
                      [0.911, 1.042],
                      [-1.237, 0.488],
                      [-1.058, 0.652],
                      [-0.781, 0.814],
                      [-0.439, 0.977],
                      [0, 1.628],
                      [0.651, 1.107],
                      [0.928, 0.749],
                      [0.993, 0.472],
                      [-1.302, 0.716],
                      [-1.254, 0.83],
                      [-0.977, 1.09],
                      [-0.603, 1.367],
                      [0, 1.595],
                      [0.862, 1.302],
                      [1.79, 0.944],
                      [2.766, 0.52],
                      [2.051, 0],
                      [2.229, -0.163],
                      [2.132, -0.472],
                      [1.92, -0.798],
                      [1.448, -1.286],
                      [0.862, -1.791],
                      [0, -1.823],
                      [-0.652, -1.318],
                      [-1.14, -0.944],
                      [-1.498, -0.618],
                      [-1.693, -0.423],
                      [-1.775, -0.293],
                      [-1.009, -0.163],
                      [-1.189, -0.211],
                      [-1.205, -0.244],
                      [-1.14, -0.309],
                      [-0.863, -0.358],
                      [-0.537, -0.391],
                      [0, -1.009],
                      [0.52, -0.764],
                      [1.27, 0.586],
                      [1.871, 0.375],
                      [2.051, 0],
                      [2.229, -0.813],
                      [1.871, -1.546],
                      [1.204, -2.246],
                      [0, -2.539],
                      [-0.619, -1.79],
                      [0, 0],
                    ],
                    v: [
                      [55.029, -43.213],
                      [57.129, -52.686],
                      [49.951, -52.222],
                      [41.943, -50.488],
                      [38.696, -51.831],
                      [35.815, -52.783],
                      [32.739, -53.369],
                      [29.004, -53.564],
                      [20.19, -52.368],
                      [13.257, -48.853],
                      [8.716, -43.213],
                      [7.08, -35.498],
                      [7.471, -30.957],
                      [8.74, -27.124],
                      [10.986, -23.779],
                      [14.355, -20.752],
                      [10.913, -19.043],
                      [8.154, -16.846],
                      [6.323, -14.16],
                      [5.664, -10.986],
                      [6.641, -6.885],
                      [9.009, -4.102],
                      [11.89, -2.271],
                      [14.404, -0.977],
                      [10.571, 1.343],
                      [7.227, 4.224],
                      [4.858, 7.91],
                      [3.955, 12.646],
                      [5.249, 16.992],
                      [9.229, 20.361],
                      [16.064, 22.559],
                      [25.879, 23.34],
                      [32.3, 23.096],
                      [38.843, 22.144],
                      [44.922, 20.239],
                      [49.976, 17.114],
                      [53.442, 12.5],
                      [54.736, 6.152],
                      [53.76, 1.44],
                      [51.074, -1.953],
                      [47.119, -4.297],
                      [42.334, -5.859],
                      [37.134, -6.934],
                      [31.934, -7.812],
                      [28.638, -8.374],
                      [25.049, -9.058],
                      [21.533, -9.888],
                      [18.53, -10.889],
                      [16.431, -12.012],
                      [15.625, -13.281],
                      [16.406, -15.942],
                      [18.164, -17.92],
                      [22.876, -16.479],
                      [30.029, -15.918],
                      [36.45, -17.139],
                      [42.603, -20.679],
                      [47.217, -26.367],
                      [49.023, -34.033],
                      [48.096, -40.527],
                      [45.947, -44.678],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "g",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-1.97, -0.326],
                      [-2.605, -0.554],
                      [-1.4, -0.342],
                      [-1.025, -0.439],
                      [-0.586, -0.57],
                      [0, -0.749],
                      [0.537, -1.009],
                      [1.237, -0.749],
                      [2.083, -0.439],
                      [3.059, 0],
                      [1.367, 0.455],
                      [1.057, 0.732],
                      [0.651, 0.96],
                      [0, 0.977],
                      [-0.13, 0.732],
                      [-0.293, 0.732],
                      [-0.456, 0.667],
                      [-0.684, 0.52],
                    ],
                    o: [
                      [1.969, 0.325],
                      [1.66, 0.358],
                      [1.399, 0.342],
                      [1.025, 0.439],
                      [0.586, 0.569],
                      [0, 1.172],
                      [-0.537, 1.009],
                      [-1.237, 0.748],
                      [-2.084, 0.439],
                      [-1.433, 0],
                      [-1.367, -0.456],
                      [-1.058, -0.732],
                      [-0.652, -0.961],
                      [0, -0.684],
                      [0.13, -0.732],
                      [0.293, -0.732],
                      [0.455, -0.668],
                      [1.692, 0.163],
                    ],
                    v: [
                      [24.78, 1.514],
                      [31.641, 2.832],
                      [36.23, 3.882],
                      [39.868, 5.054],
                      [42.285, 6.567],
                      [43.164, 8.545],
                      [42.358, 11.816],
                      [39.697, 14.453],
                      [34.717, 16.235],
                      [27.002, 16.895],
                      [22.803, 16.211],
                      [19.165, 14.429],
                      [16.602, 11.89],
                      [15.625, 8.984],
                      [15.82, 6.86],
                      [16.455, 4.663],
                      [17.578, 2.563],
                      [19.287, 0.781],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "g",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 2,
                ty: "sh",
                ix: 3,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [1.221, 0.684],
                      [0.764, 1.123],
                      [0.342, 1.482],
                      [0, 1.628],
                      [-1.611, 1.726],
                      [-2.572, 0],
                      [-1.546, -1.692],
                      [0, -3.743],
                      [0.179, -1.448],
                      [0.569, -1.09],
                      [1.074, -0.667],
                      [1.79, 0],
                    ],
                    o: [
                      [-1.221, -0.684],
                      [-0.765, -1.123],
                      [-0.342, -1.481],
                      [0, -3.45],
                      [1.611, -1.725],
                      [2.962, 0],
                      [1.546, 1.693],
                      [0, 1.562],
                      [-0.179, 1.449],
                      [-0.57, 1.091],
                      [-1.074, 0.668],
                      [-1.758, 0],
                    ],
                    v: [
                      [24.048, -24.463],
                      [21.069, -27.173],
                      [19.409, -31.079],
                      [18.896, -35.742],
                      [21.313, -43.506],
                      [27.588, -46.094],
                      [34.351, -43.555],
                      [36.67, -35.4],
                      [36.401, -30.884],
                      [35.278, -27.075],
                      [32.812, -24.438],
                      [28.516, -23.438],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "g",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "g",
            np: 6,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "y",
      size: 21,
      style: "Bold",
      w: 53.96,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.211, -0.781],
                      [0.227, -0.521],
                      [0.716, -1.53],
                      [0.83, -1.025],
                      [0.993, -0.537],
                      [1.27, 0],
                      [0.944, 0.114],
                      [0.879, 0.163],
                      [0.764, 0.227],
                      [0.488, 0.195],
                      [0, 0],
                      [-2.165, -0.716],
                      [-2.474, 0],
                      [-2.1, 0.83],
                      [-1.562, 1.579],
                      [-1.205, 2.311],
                      [-1.302, 2.962],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [-0.098, 0.749],
                      [-0.212, 0.781],
                      [-0.716, 1.953],
                      [-0.716, 1.53],
                      [-0.83, 1.025],
                      [-0.993, 0.537],
                      [-0.847, 0],
                      [-0.945, -0.114],
                      [-0.879, -0.163],
                      [-0.765, -0.228],
                      [0, 0],
                      [1.66, 1.041],
                      [2.164, 0.716],
                      [3.092, 0],
                      [2.1, -0.83],
                      [1.562, -1.579],
                      [1.204, -2.312],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.479, -52.734],
                      [1.611, -52.734],
                      [21.68, -3.467],
                      [21.216, -1.172],
                      [20.557, 0.781],
                      [18.408, 6.006],
                      [16.089, 9.839],
                      [13.354, 12.183],
                      [9.961, 12.988],
                      [7.275, 12.817],
                      [4.541, 12.402],
                      [2.075, 11.816],
                      [0.195, 11.182],
                      [-2.197, 18.896],
                      [3.54, 21.533],
                      [10.498, 22.607],
                      [18.286, 21.362],
                      [23.779, 17.749],
                      [27.93, 11.914],
                      [31.689, 4.004],
                      [52.49, -52.734],
                      [38.623, -52.734],
                      [27.686, -13.721],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "y",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "y",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: " ",
      size: 21,
      style: "Bold",
      w: 52.73,
      data: {},
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "S",
      size: 21,
      style: "Bold",
      w: 65.33,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-2.035, -1.416],
                      [-2.279, -0.96],
                      [-2.572, -0.488],
                      [-3.027, 0],
                      [-2.197, 0.391],
                      [-2.019, 0.765],
                      [-1.758, 1.189],
                      [-1.286, 1.595],
                      [-0.732, 2.019],
                      [0, 2.441],
                      [0.553, 1.888],
                      [0.911, 1.465],
                      [1.172, 1.091],
                      [1.221, 0.798],
                      [1.172, 0.57],
                      [0.944, 0.391],
                      [0.797, 0.326],
                      [0.684, 0.293],
                      [0.7, 0.31],
                      [1.009, 0.456],
                      [1.579, 0.781],
                      [1.432, 1.107],
                      [1.009, 1.449],
                      [0, 1.823],
                      [-0.765, 1.058],
                      [-1.205, 0.668],
                      [-1.482, 0.293],
                      [-1.433, 0],
                      [-1.482, -0.391],
                      [-1.254, -0.748],
                      [-1.172, -1.074],
                      [-1.302, -1.334],
                      [0, 0],
                      [1.823, 1.172],
                      [1.969, 0.749],
                      [2.18, 0.342],
                      [2.473, 0],
                      [3.125, -0.797],
                      [2.425, -1.611],
                      [1.465, -2.473],
                      [0, -3.352],
                      [-0.619, -2.018],
                      [-1.025, -1.562],
                      [-1.351, -1.172],
                      [-1.449, -0.895],
                      [-1.465, -0.667],
                      [-1.27, -0.586],
                      [-0.554, -0.244],
                      [-0.554, -0.26],
                      [-0.619, -0.26],
                      [-0.749, -0.325],
                      [-1.66, -0.846],
                      [-1.107, -0.911],
                      [-0.554, -1.074],
                      [0, -1.399],
                      [0.748, -1.367],
                      [1.237, -0.813],
                      [1.579, -0.342],
                      [1.66, 0],
                      [1.546, 0.342],
                      [1.35, 0.765],
                      [1.35, 1.237],
                      [1.725, 1.791],
                    ],
                    o: [
                      [1.888, 1.855],
                      [2.034, 1.416],
                      [2.278, 0.961],
                      [2.571, 0.488],
                      [2.213, 0],
                      [2.197, -0.391],
                      [2.018, -0.764],
                      [1.758, -1.188],
                      [1.286, -1.595],
                      [0.732, -2.018],
                      [0, -2.409],
                      [-0.554, -1.888],
                      [-0.912, -1.465],
                      [-1.172, -1.09],
                      [-1.221, -0.797],
                      [-1.172, -0.569],
                      [-1.205, -0.52],
                      [-0.798, -0.325],
                      [-0.684, -0.293],
                      [-0.7, -0.309],
                      [-1.14, -0.488],
                      [-1.579, -0.781],
                      [-1.433, -1.106],
                      [-1.009, -1.448],
                      [0, -1.53],
                      [0.764, -1.057],
                      [1.204, -0.667],
                      [1.481, -0.293],
                      [1.888, 0],
                      [1.481, 0.391],
                      [1.253, 0.749],
                      [1.172, 1.074],
                      [0, 0],
                      [-1.823, -1.627],
                      [-1.823, -1.172],
                      [-1.97, -0.748],
                      [-2.181, -0.342],
                      [-3.288, 0],
                      [-3.125, 0.798],
                      [-2.425, 1.611],
                      [-1.465, 2.474],
                      [0, 2.572],
                      [0.618, 2.019],
                      [1.025, 1.562],
                      [1.35, 1.172],
                      [1.448, 0.896],
                      [1.465, 0.668],
                      [0.618, 0.293],
                      [0.553, 0.244],
                      [0.553, 0.261],
                      [0.618, 0.261],
                      [2.18, 0.945],
                      [1.66, 0.847],
                      [1.106, 0.912],
                      [0.553, 1.074],
                      [0, 2.051],
                      [-0.749, 1.367],
                      [-1.237, 0.814],
                      [-1.579, 0.342],
                      [-2.148, 0],
                      [-1.546, -0.342],
                      [-1.351, -0.764],
                      [-1.351, -1.237],
                      [0, 0],
                    ],
                    v: [
                      [4.59, -10.156],
                      [10.474, -5.249],
                      [16.943, -1.685],
                      [24.219, 0.488],
                      [32.617, 1.221],
                      [39.233, 0.635],
                      [45.557, -1.099],
                      [51.221, -4.028],
                      [55.786, -8.203],
                      [58.813, -13.623],
                      [59.912, -20.312],
                      [59.082, -26.758],
                      [56.885, -31.787],
                      [53.76, -35.62],
                      [50.171, -38.452],
                      [46.582, -40.503],
                      [43.408, -41.943],
                      [40.405, -43.213],
                      [38.184, -44.141],
                      [36.108, -45.044],
                      [33.545, -46.191],
                      [29.468, -48.096],
                      [24.951, -50.928],
                      [21.289, -54.761],
                      [19.775, -59.668],
                      [20.923, -63.55],
                      [23.877, -66.138],
                      [27.905, -67.578],
                      [32.275, -68.018],
                      [37.329, -67.432],
                      [41.431, -65.723],
                      [45.068, -62.988],
                      [48.779, -59.375],
                      [56.25, -69.287],
                      [50.781, -73.486],
                      [45.093, -76.367],
                      [38.867, -78.003],
                      [31.885, -78.516],
                      [22.266, -77.319],
                      [13.94, -73.706],
                      [8.105, -67.578],
                      [5.908, -58.838],
                      [6.836, -51.953],
                      [9.302, -46.582],
                      [12.866, -42.48],
                      [17.065, -39.38],
                      [21.436, -37.036],
                      [25.537, -35.156],
                      [27.295, -34.351],
                      [28.955, -33.594],
                      [30.713, -32.812],
                      [32.764, -31.934],
                      [38.525, -29.248],
                      [42.676, -26.611],
                      [45.166, -23.633],
                      [45.996, -19.922],
                      [44.873, -14.795],
                      [41.895, -11.523],
                      [37.671, -9.79],
                      [32.812, -9.277],
                      [27.271, -9.79],
                      [22.925, -11.45],
                      [18.872, -14.453],
                      [14.258, -18.994],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "S",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "S",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "t",
      size: 21,
      style: "Bold",
      w: 38.53,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.439, -2.018],
                      [-1.123, -1.416],
                      [-1.888, -0.764],
                      [-2.93, 0],
                      [-2.263, 0.879],
                      [-2.344, 1.791],
                      [0, 0],
                      [1.318, -0.244],
                      [1.041, 0],
                      [0.586, 0.261],
                      [0.391, 0.619],
                      [0.211, 1.009],
                      [0, 1.498],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 2.507],
                      [0.439, 2.019],
                      [1.123, 1.416],
                      [1.888, 0.764],
                      [2.148, 0],
                      [2.262, -0.879],
                      [0, 0],
                      [-1.628, 0.619],
                      [-1.318, 0.244],
                      [-0.749, 0],
                      [-0.586, -0.26],
                      [-0.391, -0.618],
                      [-0.212, -1.009],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [2.197, -43.652],
                      [9.961, -43.652],
                      [9.961, -15.332],
                      [10.62, -8.545],
                      [12.964, -3.394],
                      [17.48, -0.122],
                      [24.707, 1.025],
                      [31.323, -0.293],
                      [38.232, -4.297],
                      [35.303, -10.498],
                      [30.884, -9.204],
                      [27.344, -8.838],
                      [25.342, -9.229],
                      [23.877, -10.547],
                      [22.974, -12.988],
                      [22.656, -16.748],
                      [22.656, -43.652],
                      [34.424, -43.652],
                      [35.596, -52.734],
                      [22.656, -52.734],
                      [22.656, -66.357],
                      [13.281, -66.357],
                      [9.961, -52.734],
                      [2.197, -50.098],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "t",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "t",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "x",
      size: 21,
      style: "Bold",
      w: 54.79,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [14.502, 0],
                      [26.758, -19.238],
                      [38.477, 0],
                      [52.344, 0],
                      [33.008, -26.416],
                      [52.148, -52.734],
                      [38.281, -52.734],
                      [27.148, -34.131],
                      [16.895, -52.734],
                      [3.027, -52.734],
                      [20.801, -26.953],
                      [0.635, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "x",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "x",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "i",
      size: 21,
      style: "Bold",
      w: 29.54,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [8.398, 0],
                      [21.094, 0],
                      [21.094, -52.734],
                      [8.398, -52.734],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "i",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-0.375, -0.862],
                      [-0.635, -0.667],
                      [-0.863, -0.407],
                      [-0.977, 0],
                      [-0.847, 0.391],
                      [-0.619, 0.652],
                      [-0.326, 0.847],
                      [0, 0.945],
                      [0.325, 0.863],
                      [0.618, 0.635],
                      [0.846, 0.375],
                      [1.041, 0],
                      [0.862, -0.342],
                      [0.635, -0.618],
                      [0.374, -0.846],
                      [0, -1.009],
                    ],
                    o: [
                      [0.374, 0.863],
                      [0.635, 0.668],
                      [0.862, 0.407],
                      [1.041, 0],
                      [0.846, -0.391],
                      [0.618, -0.651],
                      [0.325, -0.846],
                      [0, -0.944],
                      [-0.326, -0.862],
                      [-0.619, -0.635],
                      [-0.847, -0.374],
                      [-0.977, 0],
                      [-0.863, 0.342],
                      [-0.635, 0.619],
                      [-0.375, 0.847],
                      [0, 0.912],
                    ],
                    v: [
                      [8.325, -66.577],
                      [9.839, -64.282],
                      [12.085, -62.671],
                      [14.844, -62.061],
                      [17.676, -62.646],
                      [19.873, -64.209],
                      [21.289, -66.455],
                      [21.777, -69.141],
                      [21.289, -71.851],
                      [19.873, -74.097],
                      [17.676, -75.61],
                      [14.844, -76.172],
                      [12.085, -75.659],
                      [9.839, -74.219],
                      [8.325, -72.021],
                      [7.764, -69.238],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "i",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "i",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "s",
      size: 21,
      style: "Bold",
      w: 50.73,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-1.693, -1.057],
                      [-1.872, -0.618],
                      [-2.084, -0.261],
                      [-2.344, 0],
                      [-2.507, 0.651],
                      [-1.97, 1.254],
                      [-1.205, 1.872],
                      [0, 2.441],
                      [0.504, 1.482],
                      [0.813, 1.123],
                      [1.025, 0.798],
                      [1.041, 0.554],
                      [0.977, 0.359],
                      [0.684, 0.261],
                      [1.383, 0.472],
                      [1.367, 0.488],
                      [0.846, 0.342],
                      [0.667, 0.472],
                      [0.423, 0.635],
                      [0, 0.879],
                      [-0.293, 0.716],
                      [-0.635, 0.554],
                      [-0.977, 0.326],
                      [-1.367, 0],
                      [-1.27, -0.293],
                      [-1.074, -0.569],
                      [-0.961, -0.797],
                      [-1.009, -1.009],
                      [0, 0],
                      [3.304, 0.945],
                      [4.036, 0],
                      [2.393, -0.602],
                      [1.888, -1.188],
                      [1.139, -1.758],
                      [0, -2.344],
                      [-0.554, -1.448],
                      [-0.896, -1.139],
                      [-1.107, -0.813],
                      [-1.14, -0.602],
                      [-1.058, -0.407],
                      [-0.749, -0.26],
                      [-1.318, -0.439],
                      [-1.335, -0.553],
                      [-0.716, -0.374],
                      [-0.586, -0.488],
                      [-0.359, -0.651],
                      [0, -0.813],
                      [0.439, -0.813],
                      [0.748, -0.52],
                      [1.041, -0.244],
                      [1.204, 0],
                      [4.817, 5.339],
                    ],
                    o: [
                      [1.497, 1.595],
                      [1.692, 1.058],
                      [1.871, 0.618],
                      [2.083, 0.26],
                      [2.637, 0],
                      [2.506, -0.651],
                      [1.969, -1.253],
                      [1.204, -1.871],
                      [0, -1.953],
                      [-0.505, -1.481],
                      [-0.814, -1.123],
                      [-1.025, -0.797],
                      [-1.042, -0.553],
                      [-0.977, -0.358],
                      [-1.367, -0.488],
                      [-1.384, -0.471],
                      [-0.879, -0.293],
                      [-0.847, -0.342],
                      [-0.668, -0.471],
                      [-0.423, -0.635],
                      [0, -0.781],
                      [0.293, -0.716],
                      [0.635, -0.553],
                      [0.977, -0.325],
                      [1.627, 0],
                      [1.27, 0.293],
                      [1.074, 0.57],
                      [0.96, 0.798],
                      [0, 0],
                      [-2.734, -2.213],
                      [-3.304, -0.944],
                      [-2.539, 0],
                      [-2.393, 0.603],
                      [-1.888, 1.189],
                      [-1.14, 1.758],
                      [0, 1.888],
                      [0.553, 1.449],
                      [0.895, 1.14],
                      [1.106, 0.814],
                      [1.139, 0.603],
                      [1.057, 0.407],
                      [1.334, 0.554],
                      [1.318, 0.439],
                      [0.716, 0.261],
                      [0.716, 0.375],
                      [0.586, 0.488],
                      [0.358, 0.652],
                      [0, 1.14],
                      [-0.439, 0.814],
                      [-0.749, 0.521],
                      [-1.042, 0.244],
                      [-5.469, 0],
                      [0, 0],
                    ],
                    v: [
                      [3.613, -7.031],
                      [8.398, -3.052],
                      [13.745, -0.537],
                      [19.678, 0.781],
                      [26.318, 1.172],
                      [34.033, 0.195],
                      [40.747, -2.661],
                      [45.508, -7.349],
                      [47.314, -13.818],
                      [46.558, -18.97],
                      [44.58, -22.876],
                      [41.821, -25.757],
                      [38.721, -27.783],
                      [35.693, -29.15],
                      [33.203, -30.078],
                      [29.077, -31.519],
                      [24.951, -32.959],
                      [22.363, -33.911],
                      [20.093, -35.132],
                      [18.457, -36.792],
                      [17.822, -39.062],
                      [18.262, -41.309],
                      [19.653, -43.213],
                      [22.07, -44.531],
                      [25.586, -45.02],
                      [29.932, -44.58],
                      [33.447, -43.286],
                      [36.499, -41.235],
                      [39.453, -38.525],
                      [45.215, -47.412],
                      [36.157, -52.148],
                      [25.146, -53.564],
                      [17.749, -52.661],
                      [11.328, -49.976],
                      [6.787, -45.557],
                      [5.078, -39.404],
                      [5.908, -34.399],
                      [8.081, -30.518],
                      [11.084, -27.588],
                      [14.453, -25.464],
                      [17.749, -23.95],
                      [20.459, -22.949],
                      [24.438, -21.46],
                      [28.418, -19.971],
                      [30.566, -19.019],
                      [32.52, -17.725],
                      [33.936, -16.016],
                      [34.473, -13.818],
                      [33.813, -10.889],
                      [32.031, -8.887],
                      [29.346, -7.739],
                      [25.977, -7.373],
                      [10.547, -15.381],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "s",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "s",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "w",
      size: 21,
      style: "Bold",
      w: 74.95,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [21.094, 0],
                      [29.932, 0],
                      [37.842, -34.766],
                      [46.924, 0],
                      [55.273, 0],
                      [72.656, -52.734],
                      [58.789, -52.734],
                      [50.586, -17.529],
                      [41.016, -52.734],
                      [34.131, -52.734],
                      [25.83, -17.48],
                      [16.162, -52.734],
                      [2.295, -52.734],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "w",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "w",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "W",
      size: 21,
      style: "Bold",
      w: 97.41,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [67.969, -17.725],
                      [54.346, -76.514],
                      [44.727, -76.514],
                      [30.273, -17.529],
                      [17.871, -76.514],
                      [3.125, -76.514],
                      [23.242, 0],
                      [35.254, 0],
                      [49.512, -59.229],
                      [62.695, 0],
                      [74.902, 0],
                      [95.459, -76.514],
                      [79.785, -76.514],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "W",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "W",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "h",
      size: 21,
      style: "Bold",
      w: 62.4,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-0.993, 0.342],
                      [-0.945, 0.244],
                      [-0.928, 0.114],
                      [-0.977, 0],
                      [-1.726, -1.579],
                      [0, -3.418],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.96, 2.393],
                      [1.79, 1.628],
                      [2.555, 0.847],
                      [3.157, 0],
                      [1.35, -0.276],
                      [1.123, -0.455],
                      [0.895, -0.586],
                      [0.716, -0.586],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [1.106, -0.455],
                      [0.993, -0.342],
                      [0.944, -0.244],
                      [0.928, -0.114],
                      [3.059, 0],
                      [1.725, 1.579],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -3.027],
                      [-0.961, -2.393],
                      [-1.791, -1.627],
                      [-2.556, -0.846],
                      [-1.562, 0],
                      [-1.351, 0.277],
                      [-1.123, 0.456],
                      [-0.896, 0.586],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [7.764, 0],
                      [20.459, 0],
                      [20.459, -41.309],
                      [23.608, -42.505],
                      [26.514, -43.384],
                      [29.321, -43.921],
                      [32.178, -44.092],
                      [39.355, -41.724],
                      [41.943, -34.229],
                      [41.943, 0],
                      [54.639, 0],
                      [54.639, -34.424],
                      [53.198, -42.554],
                      [49.072, -48.584],
                      [42.554, -52.295],
                      [33.984, -53.564],
                      [29.614, -53.149],
                      [25.903, -52.051],
                      [22.876, -50.488],
                      [20.459, -48.73],
                      [20.459, -76.514],
                      [7.764, -76.514],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "h",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "h",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "R",
      size: 21,
      style: "Bold",
      w: 64.06,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-1.042, -0.032],
                      [-0.814, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-2.312, 1.693],
                      [-1.351, 2.051],
                      [-0.537, 2.263],
                      [0, 2.148],
                      [1.123, 2.605],
                      [2.327, 1.823],
                      [3.548, 0.977],
                      [4.883, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [1.367, 0.228],
                      [1.041, 0.033],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [3.548, -1.041],
                      [2.311, -1.692],
                      [1.35, -2.051],
                      [0.537, -2.262],
                      [0, -3.288],
                      [-1.123, -2.604],
                      [-2.328, -1.823],
                      [-3.548, -0.977],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [20.752, -31.738],
                      [24.365, -31.348],
                      [27.148, -31.299],
                      [47.607, 0],
                      [62.695, 0],
                      [39.404, -32.568],
                      [48.193, -36.67],
                      [53.687, -42.285],
                      [56.519, -48.755],
                      [57.324, -55.371],
                      [55.64, -64.209],
                      [50.464, -70.85],
                      [41.65, -75.049],
                      [29.004, -76.514],
                      [7.324, -76.514],
                      [7.324, 0],
                      [20.703, 0],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "R",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [-2.197, -0.455],
                      [-1.302, -0.96],
                      [-0.521, -1.497],
                      [0, -2.116],
                      [0.764, -1.676],
                      [1.465, -1.172],
                      [2.116, -0.618],
                      [2.669, 0],
                      [1.041, 0.033],
                      [1.009, 0.13],
                    ],
                    o: [
                      [0, 0],
                      [3.352, 0],
                      [2.197, 0.456],
                      [1.302, 0.961],
                      [0.52, 1.498],
                      [0, 2.116],
                      [-0.765, 1.677],
                      [-1.465, 1.172],
                      [-2.116, 0.619],
                      [-1.074, 0],
                      [-1.042, -0.032],
                      [0, 0],
                    ],
                    v: [
                      [20.752, -66.65],
                      [26.953, -66.65],
                      [35.278, -65.967],
                      [40.527, -63.843],
                      [43.262, -60.156],
                      [44.043, -54.736],
                      [42.896, -49.048],
                      [39.551, -44.775],
                      [34.18, -42.09],
                      [27.002, -41.162],
                      [23.828, -41.211],
                      [20.752, -41.455],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "R",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "R",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "p",
      size: 21,
      style: "Bold",
      w: 62.3,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-0.114, -1.074],
                      [-0.049, -0.993],
                      [-0.017, -0.781],
                      [0, -0.195],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-4.134, 0],
                      [-3.044, 1.562],
                      [-2.002, 2.621],
                      [-0.993, 3.435],
                      [0, 3.744],
                      [0.732, 3.191],
                      [1.709, 2.441],
                      [2.864, 1.465],
                      [4.231, 0],
                      [1.318, -0.325],
                      [1.074, -0.504],
                      [0.879, -0.667],
                      [0.781, -0.684],
                      [0.227, 0.896],
                      [0.195, 0.488],
                    ],
                    o: [
                      [0.227, 0.781],
                      [0.114, 1.074],
                      [0.049, 0.993],
                      [0.016, 0.781],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [3.19, 2.506],
                      [4.102, 0],
                      [3.043, -1.562],
                      [2.002, -2.62],
                      [0.993, -3.434],
                      [0, -3.45],
                      [-0.732, -3.19],
                      [-1.709, -2.441],
                      [-2.865, -1.465],
                      [-1.66, 0],
                      [-1.318, 0.326],
                      [-1.074, 0.505],
                      [-0.879, 0.668],
                      [-0.098, -0.846],
                      [-0.228, -0.895],
                      [0, 0],
                    ],
                    v: [
                      [7.666, -52.734],
                      [8.179, -49.951],
                      [8.423, -46.851],
                      [8.521, -44.189],
                      [8.545, -42.725],
                      [8.545, 22.119],
                      [21.24, 22.119],
                      [21.24, -2.393],
                      [32.227, 1.367],
                      [42.944, -0.977],
                      [50.513, -7.251],
                      [55.005, -16.333],
                      [56.494, -27.1],
                      [55.396, -37.061],
                      [51.733, -45.508],
                      [44.873, -51.367],
                      [34.229, -53.564],
                      [29.761, -53.076],
                      [26.172, -51.831],
                      [23.242, -50.073],
                      [20.752, -48.047],
                      [20.264, -50.659],
                      [19.629, -52.734],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "p",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-1.514, -0.83],
                      [-0.945, -1.481],
                      [-0.456, -2.051],
                      [0, -2.409],
                      [0.423, -2.278],
                      [0.879, -1.79],
                      [1.383, -1.09],
                      [1.953, 0],
                      [0.928, 0.033],
                      [0.895, 0.195],
                      [0.862, 0.391],
                      [0.879, 0.716],
                      [0, 0],
                      [-1.579, 0.407],
                      [-1.726, 0],
                    ],
                    o: [
                      [1.514, 0.83],
                      [0.944, 1.482],
                      [0.455, 2.051],
                      [0, 2.377],
                      [-0.423, 2.279],
                      [-0.879, 1.791],
                      [-1.384, 1.091],
                      [-0.977, 0],
                      [-0.928, -0.032],
                      [-0.896, -0.195],
                      [-0.863, -0.391],
                      [0, 0],
                      [1.758, -0.944],
                      [1.579, -0.407],
                      [2.083, 0],
                    ],
                    v: [
                      [36.597, -42.749],
                      [40.283, -39.282],
                      [42.383, -33.984],
                      [43.066, -27.295],
                      [42.432, -20.312],
                      [40.479, -14.209],
                      [37.085, -9.888],
                      [32.08, -8.252],
                      [29.224, -8.301],
                      [26.489, -8.643],
                      [23.853, -9.521],
                      [21.24, -11.182],
                      [21.24, -41.357],
                      [26.245, -43.384],
                      [31.201, -43.994],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "p",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "p",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "C",
      size: 21,
      style: "Bold",
      w: 69.82,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [1.074, -1.188],
                      [1.35, -0.813],
                      [1.774, -0.439],
                      [2.473, 0],
                      [2.278, 1.644],
                      [1.627, 2.881],
                      [0.895, 3.89],
                      [0, 4.525],
                      [-0.749, 3.223],
                      [-1.562, 2.507],
                      [-2.409, 1.514],
                      [-3.32, 0],
                      [-1.4, -0.26],
                      [-1.27, -0.586],
                      [-1.189, -0.911],
                      [-1.205, -1.27],
                      [0, 0],
                      [1.725, 1.107],
                      [1.871, 0.652],
                      [2.1, 0.293],
                      [2.344, 0],
                      [3.174, -1.009],
                      [2.49, -1.823],
                      [1.807, -2.49],
                      [1.172, -2.946],
                      [0.569, -3.32],
                      [0, -3.418],
                      [-1.384, -4.85],
                      [-2.751, -3.645],
                      [-4.086, -2.132],
                      [-5.404, 0],
                      [-2.295, 0.309],
                      [-2.068, 0.911],
                      [-1.986, 1.611],
                      [-2.214, 2.637],
                    ],
                    o: [
                      [-1.074, 1.53],
                      [-1.074, 1.189],
                      [-1.351, 0.814],
                      [-1.775, 0.439],
                      [-2.8, 0],
                      [-2.279, -1.643],
                      [-1.628, -2.881],
                      [-0.896, -3.889],
                      [0, -3.45],
                      [0.748, -3.223],
                      [1.562, -2.506],
                      [2.409, -1.514],
                      [1.66, 0],
                      [1.399, 0.261],
                      [1.27, 0.586],
                      [1.188, 0.912],
                      [0, 0],
                      [-1.628, -1.595],
                      [-1.726, -1.106],
                      [-1.872, -0.651],
                      [-2.1, -0.293],
                      [-3.906, 0],
                      [-3.174, 1.009],
                      [-2.49, 1.823],
                      [-1.807, 2.49],
                      [-1.172, 2.946],
                      [-0.57, 3.32],
                      [0, 5.437],
                      [1.383, 4.851],
                      [2.75, 3.646],
                      [4.085, 2.132],
                      [2.864, 0],
                      [2.295, -0.31],
                      [2.067, -0.911],
                      [1.985, -1.611],
                      [0, 0],
                    ],
                    v: [
                      [56.787, -18.701],
                      [53.564, -14.624],
                      [49.927, -11.621],
                      [45.239, -9.741],
                      [38.867, -9.082],
                      [31.25, -11.548],
                      [25.391, -18.335],
                      [21.606, -28.491],
                      [20.264, -41.113],
                      [21.387, -51.123],
                      [24.854, -59.717],
                      [30.811, -65.747],
                      [39.404, -68.018],
                      [43.994, -67.627],
                      [47.998, -66.357],
                      [51.685, -64.111],
                      [55.273, -60.84],
                      [62.646, -69.971],
                      [57.617, -74.023],
                      [52.222, -76.66],
                      [46.265, -78.076],
                      [39.6, -78.516],
                      [28.979, -77.002],
                      [20.483, -72.754],
                      [14.038, -66.284],
                      [9.57, -58.13],
                      [6.958, -48.73],
                      [6.104, -38.623],
                      [8.179, -23.193],
                      [14.38, -10.449],
                      [24.634, -1.782],
                      [38.867, 1.416],
                      [46.606, 0.952],
                      [53.149, -0.879],
                      [59.229, -4.663],
                      [65.527, -11.035],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "C",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "C",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "d",
      size: 21,
      style: "Bold",
      w: 64.79,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [3.157, -1.514],
                      [2.213, -2.506],
                      [1.172, -3.255],
                      [0, -3.516],
                      [-1.058, -3.352],
                      [-2.019, -2.441],
                      [-2.914, -1.399],
                      [-3.679, 0],
                      [-2.295, 1.123],
                      [-1.758, 2.051],
                      [-0.261, -0.537],
                      [-0.326, -0.488],
                      [-0.342, -0.423],
                      [-0.326, -0.26],
                      [0, 0],
                      [0.455, 1.562],
                      [0.293, 1.579],
                      [0.13, 1.53],
                      [0, 1.367],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [1.758, 0.554],
                      [2.539, 0],
                    ],
                    o: [
                      [-3.158, 1.514],
                      [-2.214, 2.507],
                      [-1.172, 3.255],
                      [0, 3.906],
                      [1.057, 3.353],
                      [2.018, 2.441],
                      [2.913, 1.399],
                      [2.93, 0],
                      [2.295, -1.123],
                      [0.163, 0.488],
                      [0.26, 0.537],
                      [0.325, 0.488],
                      [0.342, 0.423],
                      [0, 0],
                      [-0.652, -1.399],
                      [-0.456, -1.562],
                      [-0.293, -1.579],
                      [-0.13, -1.53],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [-1.172, -0.846],
                      [-1.758, -0.553],
                      [-4.004, 0],
                    ],
                    v: [
                      [20.703, -51.294],
                      [12.646, -45.264],
                      [7.568, -36.621],
                      [5.811, -26.465],
                      [7.397, -15.576],
                      [12.012, -6.885],
                      [19.409, -1.123],
                      [29.297, 0.977],
                      [37.134, -0.708],
                      [43.213, -5.469],
                      [43.848, -3.931],
                      [44.727, -2.393],
                      [45.728, -1.025],
                      [46.729, 0],
                      [58.594, 0],
                      [56.934, -4.443],
                      [55.811, -9.155],
                      [55.176, -13.818],
                      [54.98, -18.164],
                      [54.98, -76.514],
                      [42.285, -76.514],
                      [42.285, -50.635],
                      [37.891, -52.734],
                      [31.445, -53.564],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "d",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [1.546, 1.025],
                      [1.025, 1.709],
                      [0.504, 2.197],
                      [0, 2.344],
                      [-0.619, 2.068],
                      [-1.172, 1.546],
                      [-1.709, 0.912],
                      [-2.214, 0],
                      [-1.53, -0.358],
                      [-1.367, -0.618],
                      [0, 0],
                      [1.66, -0.407],
                      [1.985, 0],
                    ],
                    o: [
                      [-1.546, -1.025],
                      [-1.025, -1.709],
                      [-0.505, -2.197],
                      [0, -2.311],
                      [0.618, -2.067],
                      [1.172, -1.546],
                      [1.709, -0.911],
                      [1.758, 0],
                      [1.53, 0.359],
                      [0, 0],
                      [-1.855, 1.042],
                      [-1.66, 0.407],
                      [-2.084, 0],
                    ],
                    v: [
                      [26.099, -10.181],
                      [22.241, -14.282],
                      [19.946, -20.142],
                      [19.189, -26.953],
                      [20.117, -33.521],
                      [22.803, -38.94],
                      [27.124, -42.627],
                      [33.008, -43.994],
                      [37.939, -43.457],
                      [42.285, -41.992],
                      [42.285, -11.426],
                      [37.012, -9.253],
                      [31.543, -8.643],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "d",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "d",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "F",
      size: 21,
      style: "Bold",
      w: 53.61,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [50.586, -76.514],
                      [7.227, -76.514],
                      [7.227, 0],
                      [20.654, 0],
                      [20.654, -35.791],
                      [44.482, -35.791],
                      [44.482, -45.654],
                      [20.654, -45.654],
                      [20.654, -66.602],
                      [50.586, -66.602],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "F",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "F",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: ":",
      size: 21,
      style: "Bold",
      w: 28.42,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-0.359, -0.846],
                      [-0.619, -0.635],
                      [-0.83, -0.358],
                      [-0.912, 0],
                      [-0.814, 0.359],
                      [-0.619, 0.635],
                      [-0.342, 0.847],
                      [0, 0.977],
                      [0.342, 0.847],
                      [0.618, 0.635],
                      [0.813, 0.359],
                      [0.911, 0],
                      [0.83, -0.358],
                      [0.618, -0.635],
                      [0.358, -0.846],
                      [0, -0.977],
                    ],
                    o: [
                      [0.358, 0.847],
                      [0.618, 0.635],
                      [0.83, 0.359],
                      [0.911, 0],
                      [0.813, -0.358],
                      [0.618, -0.635],
                      [0.342, -0.846],
                      [0, -0.977],
                      [-0.342, -0.846],
                      [-0.619, -0.635],
                      [-0.814, -0.358],
                      [-0.912, 0],
                      [-0.83, 0.359],
                      [-0.619, 0.635],
                      [-0.359, 0.847],
                      [0, 0.977],
                    ],
                    v: [
                      [8.594, -43.75],
                      [10.059, -41.528],
                      [12.231, -40.039],
                      [14.844, -39.502],
                      [17.432, -40.039],
                      [19.58, -41.528],
                      [21.021, -43.75],
                      [21.533, -46.484],
                      [21.021, -49.219],
                      [19.58, -51.44],
                      [17.432, -52.93],
                      [14.844, -53.467],
                      [12.231, -52.93],
                      [10.059, -51.44],
                      [8.594, -49.219],
                      [8.057, -46.484],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: ":",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-0.359, -0.846],
                      [-0.619, -0.635],
                      [-0.83, -0.358],
                      [-0.912, 0],
                      [-0.814, 0.358],
                      [-0.619, 0.635],
                      [-0.342, 0.847],
                      [0, 0.977],
                      [0.342, 0.847],
                      [0.618, 0.635],
                      [0.813, 0.359],
                      [0.911, 0],
                      [0.83, -0.358],
                      [0.618, -0.635],
                      [0.358, -0.846],
                      [0, -0.977],
                    ],
                    o: [
                      [0.358, 0.847],
                      [0.618, 0.635],
                      [0.83, 0.358],
                      [0.911, 0],
                      [0.813, -0.358],
                      [0.618, -0.635],
                      [0.342, -0.846],
                      [0, -0.977],
                      [-0.342, -0.846],
                      [-0.619, -0.635],
                      [-0.814, -0.358],
                      [-0.912, 0],
                      [-0.83, 0.359],
                      [-0.619, 0.635],
                      [-0.359, 0.847],
                      [0, 0.977],
                    ],
                    v: [
                      [8.594, -3.564],
                      [10.059, -1.343],
                      [12.231, 0.146],
                      [14.844, 0.684],
                      [17.432, 0.146],
                      [19.58, -1.343],
                      [21.021, -3.564],
                      [21.533, -6.299],
                      [21.021, -9.033],
                      [19.58, -11.255],
                      [17.432, -12.744],
                      [14.844, -13.281],
                      [12.231, -12.744],
                      [10.059, -11.255],
                      [8.594, -9.033],
                      [8.057, -6.299],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: ":",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: ":",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "“",
      size: 21,
      style: "Bold",
      w: 45.02,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [1.611, -1.025],
                      [1.221, -1.334],
                      [0.716, -1.758],
                      [0, -2.376],
                      [-0.391, -1.172],
                      [-0.847, -0.977],
                      [-1.335, -0.618],
                      [-1.855, 0],
                      [-0.814, 0.375],
                      [-0.57, 0.619],
                      [-0.31, 0.798],
                      [0, 0.847],
                      [0.944, 1.058],
                      [1.855, 0],
                      [0.553, -0.195],
                      [0.195, -0.163],
                      [0.065, 0.326],
                      [0, 0.359],
                      [-0.407, 0.896],
                      [-0.716, 0.765],
                      [-0.977, 0.684],
                      [-1.14, 0.716],
                    ],
                    o: [
                      [-1.791, 0.879],
                      [-1.611, 1.025],
                      [-1.221, 1.335],
                      [-0.716, 1.758],
                      [0, 1.107],
                      [0.391, 1.172],
                      [0.846, 0.977],
                      [1.334, 0.619],
                      [1.009, 0],
                      [0.813, -0.374],
                      [0.569, -0.618],
                      [0.309, -0.797],
                      [0, -1.66],
                      [-0.945, -1.057],
                      [-0.652, 0],
                      [-0.554, 0.195],
                      [-0.098, -0.391],
                      [-0.066, -0.325],
                      [0, -1.106],
                      [0.407, -0.895],
                      [0.716, -0.764],
                      [0.977, -0.684],
                      [0, 0],
                    ],
                    v: [
                      [37.939, -86.816],
                      [32.837, -83.96],
                      [28.589, -80.42],
                      [25.684, -75.781],
                      [24.609, -69.58],
                      [25.195, -66.162],
                      [27.051, -62.939],
                      [30.322, -60.547],
                      [35.107, -59.619],
                      [37.842, -60.181],
                      [39.917, -61.67],
                      [41.235, -63.794],
                      [41.699, -66.26],
                      [40.283, -70.337],
                      [36.084, -71.924],
                      [34.277, -71.631],
                      [33.154, -71.094],
                      [32.91, -72.168],
                      [32.812, -73.193],
                      [33.423, -76.196],
                      [35.107, -78.687],
                      [37.646, -80.859],
                      [40.82, -82.959],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "“",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [1.611, -1.025],
                      [1.221, -1.334],
                      [0.716, -1.758],
                      [0, -2.376],
                      [-0.391, -1.172],
                      [-0.847, -0.977],
                      [-1.335, -0.618],
                      [-1.855, 0],
                      [-0.814, 0.375],
                      [-0.57, 0.619],
                      [-0.31, 0.798],
                      [0, 0.847],
                      [0.944, 1.058],
                      [1.855, 0],
                      [0.553, -0.195],
                      [0.195, -0.163],
                      [0.065, 0.326],
                      [0, 0.359],
                      [-0.407, 0.896],
                      [-0.716, 0.765],
                      [-0.977, 0.684],
                      [-1.14, 0.716],
                    ],
                    o: [
                      [-1.791, 0.879],
                      [-1.611, 1.025],
                      [-1.221, 1.335],
                      [-0.716, 1.758],
                      [0, 1.107],
                      [0.391, 1.172],
                      [0.846, 0.977],
                      [1.334, 0.619],
                      [1.009, 0],
                      [0.813, -0.374],
                      [0.569, -0.618],
                      [0.309, -0.797],
                      [0, -1.66],
                      [-0.945, -1.057],
                      [-0.652, 0],
                      [-0.554, 0.195],
                      [-0.098, -0.391],
                      [-0.066, -0.325],
                      [0, -1.106],
                      [0.407, -0.895],
                      [0.716, -0.764],
                      [0.977, -0.684],
                      [0, 0],
                    ],
                    v: [
                      [16.455, -86.816],
                      [11.353, -83.96],
                      [7.104, -80.42],
                      [4.199, -75.781],
                      [3.125, -69.58],
                      [3.711, -66.162],
                      [5.566, -62.939],
                      [8.838, -60.547],
                      [13.623, -59.619],
                      [16.357, -60.181],
                      [18.433, -61.67],
                      [19.751, -63.794],
                      [20.215, -66.26],
                      [18.799, -70.337],
                      [14.6, -71.924],
                      [12.793, -71.631],
                      [11.67, -71.094],
                      [11.426, -72.168],
                      [11.328, -73.193],
                      [11.938, -76.196],
                      [13.623, -78.687],
                      [16.162, -80.859],
                      [19.336, -82.959],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "“",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "“",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "”",
      size: 21,
      style: "Bold",
      w: 48.49,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-1.611, 1.025],
                      [-1.205, 1.335],
                      [-0.716, 1.775],
                      [0, 2.344],
                      [0.391, 1.172],
                      [0.846, 0.977],
                      [1.318, 0.619],
                      [1.888, 0],
                      [0.797, -0.374],
                      [0.569, -0.618],
                      [0.309, -0.797],
                      [0, -0.846],
                      [-0.945, -1.074],
                      [-1.823, 0],
                      [-0.554, 0.195],
                      [-0.195, 0.163],
                      [-0.066, -0.325],
                      [0, -0.358],
                      [0.407, -0.895],
                      [0.716, -0.748],
                      [0.977, -0.7],
                      [1.139, -0.716],
                    ],
                    o: [
                      [1.79, -0.879],
                      [1.611, -1.025],
                      [1.204, -1.334],
                      [0.716, -1.774],
                      [0, -1.106],
                      [-0.391, -1.172],
                      [-0.847, -0.977],
                      [-1.318, -0.618],
                      [-1.009, 0],
                      [-0.798, 0.375],
                      [-0.57, 0.619],
                      [-0.31, 0.798],
                      [0, 1.628],
                      [0.944, 1.074],
                      [0.651, 0],
                      [0.553, -0.195],
                      [0.098, 0.391],
                      [0.065, 0.326],
                      [0, 1.107],
                      [-0.407, 0.896],
                      [-0.716, 0.749],
                      [-0.977, 0.7],
                      [0, 0],
                    ],
                    v: [
                      [29.98, -59.668],
                      [35.083, -62.524],
                      [39.307, -66.064],
                      [42.188, -70.728],
                      [43.262, -76.904],
                      [42.676, -80.322],
                      [40.82, -83.545],
                      [37.573, -85.938],
                      [32.764, -86.865],
                      [30.054, -86.304],
                      [28.003, -84.814],
                      [26.685, -82.69],
                      [26.221, -80.225],
                      [27.637, -76.172],
                      [31.787, -74.561],
                      [33.594, -74.854],
                      [34.717, -75.391],
                      [34.961, -74.316],
                      [35.059, -73.291],
                      [34.448, -70.288],
                      [32.764, -67.822],
                      [30.225, -65.649],
                      [27.051, -63.525],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "”",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [-1.611, 1.025],
                      [-1.205, 1.335],
                      [-0.716, 1.775],
                      [0, 2.344],
                      [0.391, 1.172],
                      [0.846, 0.977],
                      [1.318, 0.619],
                      [1.888, 0],
                      [0.797, -0.374],
                      [0.569, -0.618],
                      [0.309, -0.797],
                      [0, -0.846],
                      [-0.945, -1.074],
                      [-1.823, 0],
                      [-0.554, 0.195],
                      [-0.195, 0.163],
                      [-0.066, -0.325],
                      [0, -0.358],
                      [0.407, -0.895],
                      [0.716, -0.748],
                      [0.977, -0.7],
                      [1.139, -0.716],
                    ],
                    o: [
                      [1.79, -0.879],
                      [1.611, -1.025],
                      [1.204, -1.334],
                      [0.716, -1.774],
                      [0, -1.106],
                      [-0.391, -1.172],
                      [-0.847, -0.977],
                      [-1.318, -0.618],
                      [-1.009, 0],
                      [-0.798, 0.375],
                      [-0.57, 0.619],
                      [-0.31, 0.798],
                      [0, 1.628],
                      [0.944, 1.074],
                      [0.651, 0],
                      [0.553, -0.195],
                      [0.098, 0.391],
                      [0.065, 0.326],
                      [0, 1.107],
                      [-0.407, 0.896],
                      [-0.716, 0.749],
                      [-0.977, 0.7],
                      [0, 0],
                    ],
                    v: [
                      [6.982, -59.668],
                      [12.085, -62.524],
                      [16.309, -66.064],
                      [19.189, -70.728],
                      [20.264, -76.904],
                      [19.678, -80.322],
                      [17.822, -83.545],
                      [14.575, -85.938],
                      [9.766, -86.865],
                      [7.056, -86.304],
                      [5.005, -84.814],
                      [3.687, -82.69],
                      [3.223, -80.225],
                      [4.639, -76.172],
                      [8.789, -74.561],
                      [10.596, -74.854],
                      [11.719, -75.391],
                      [11.963, -74.316],
                      [12.061, -73.291],
                      [11.45, -70.288],
                      [9.766, -67.822],
                      [7.227, -65.649],
                      [4.053, -63.525],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "”",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "”",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "O",
      size: 21,
      style: "Bold",
      w: 82.03,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [1.709, 4.785],
                      [3.059, 3.32],
                      [4.248, 1.775],
                      [5.078, 0],
                      [4.346, -1.953],
                      [3.027, -3.516],
                      [1.627, -4.85],
                      [0, -5.794],
                      [-1.562, -4.964],
                      [-2.979, -3.548],
                      [-4.314, -1.953],
                      [-5.534, 0],
                      [-3.06, 0.977],
                      [-2.588, 1.791],
                      [-2.068, 2.507],
                      [-1.449, 3.076],
                      [-0.765, 3.548],
                      [0, 3.841],
                    ],
                    o: [
                      [-1.709, -4.785],
                      [-3.06, -3.32],
                      [-4.248, -1.774],
                      [-5.437, 0],
                      [-4.346, 1.953],
                      [-3.027, 3.516],
                      [-1.628, 4.851],
                      [0, 6.023],
                      [1.562, 4.964],
                      [2.979, 3.548],
                      [4.313, 1.953],
                      [3.45, 0],
                      [3.059, -0.977],
                      [2.588, -1.79],
                      [2.067, -2.506],
                      [1.448, -3.076],
                      [0.764, -3.548],
                      [0, -5.989],
                    ],
                    v: [
                      [73.364, -56.006],
                      [66.211, -68.164],
                      [55.249, -75.806],
                      [41.26, -78.467],
                      [26.587, -75.537],
                      [15.527, -67.334],
                      [8.545, -54.785],
                      [6.104, -38.818],
                      [8.447, -22.339],
                      [15.259, -9.57],
                      [26.196, -1.318],
                      [40.967, 1.611],
                      [50.732, 0.146],
                      [59.204, -4.004],
                      [66.187, -10.449],
                      [71.46, -18.823],
                      [74.78, -28.76],
                      [75.928, -39.844],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "O",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0.96, -3.58],
                      [1.823, -2.75],
                      [2.62, -1.643],
                      [3.32, 0],
                      [2.539, 1.53],
                      [1.709, 2.734],
                      [0.862, 3.728],
                      [0, 4.395],
                      [-1.025, 3.516],
                      [-1.839, 2.49],
                      [-2.556, 1.335],
                      [-3.093, 0],
                      [-2.539, -1.416],
                      [-1.791, -2.571],
                      [-0.961, -3.596],
                      [0, -4.395],
                    ],
                    o: [
                      [-0.961, 3.581],
                      [-1.823, 2.751],
                      [-2.621, 1.644],
                      [-3.32, 0],
                      [-2.539, -1.53],
                      [-1.709, -2.734],
                      [-0.863, -3.727],
                      [0, -4.329],
                      [1.025, -3.516],
                      [1.839, -2.49],
                      [2.555, -1.334],
                      [3.157, 0],
                      [2.539, 1.416],
                      [1.79, 2.572],
                      [0.96, 3.597],
                      [0, 3.874],
                    ],
                    v: [
                      [60.327, -27.441],
                      [56.152, -17.944],
                      [49.487, -11.353],
                      [40.576, -8.887],
                      [31.787, -11.182],
                      [25.415, -17.578],
                      [21.558, -27.271],
                      [20.264, -39.453],
                      [21.802, -51.221],
                      [26.099, -60.229],
                      [32.69, -65.967],
                      [41.162, -67.969],
                      [49.707, -65.845],
                      [56.201, -59.863],
                      [60.327, -50.61],
                      [61.768, -38.623],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "O",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "O",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
    {
      ch: "v",
      size: 21,
      style: "Bold",
      w: 58.25,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                    ],
                    v: [
                      [15.967, -52.734],
                      [2.1, -52.734],
                      [23.73, 0],
                      [34.863, 0],
                      [56.055, -52.734],
                      [42.188, -52.734],
                      [29.199, -11.719],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "v",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "v",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Euphemia UCAS",
    },
  ],
};

var params = {
  container: document.getElementById("lottie"),
  renderer: "svg",
  loop: false,
  autoplay: true,
  animationData: animationData,
};

var anim;

anim = lottie.loadAnimation(params);

(function ($) {
  $(document).ready(function () {
    $(".col-two-content .row #lottie .png").click(function () {
      $(".col-two-content .row #lottie .png, .col-two-content .row .content-wrap .column-wrap").removeClass("active");
      $(this).addClass("active");
      var tabId = $(this).data("tab");
      $("#" + tabId).addClass("active");
    });
    $('.col-two-content .row #lottie .png').each(function (index) {
      $(this).attr('data-tab', 'tab' + (index + 1));
    });
  });

})(jQuery);
